(function () {
  if (window.VaultProduct) { window.vaultInit.drain('Product'); return; }
  // Read only the price currently shown, including the schedule placeholder.
  window.VaultPriceFade = window.VaultPriceFade || {
    read: function (box) {
      if (!box) return '';
      var original = box.querySelector('[data-ai-pdp-price-original]');
      var reveal = box.querySelector('[data-ai-pdp-price-reveal]');
      var target = original && (original.style.visibility === 'hidden' || original.style.display === 'none') ? reveal : (original || box);
      if (!target || target.style.display === 'none' || target.style.visibility === 'hidden') return '';
      var price = target.querySelector('.price');
      var item = price && price.querySelector(price.classList.contains('price--on-sale') ? '.price__sale .price-item--last' : '.price__regular .price-item--regular');
      return (item || target).textContent.replace(/\s+/g, ' ').trim();
    },
    play: function (box, before) {
      if (!box) return;
      var after = this.read(box);
      var running = box.__vaultPriceAnimation;
      if (before === after) {
        /* same price, but the copy was rebuilt mid-fade (mobile price sync): keep the fade going on the new node */
        if (running && running.playState === 'running' && running.effect && running.effect.target && !box.contains(running.effect.target)) {
          var t = running.currentTime;
          running.cancel();
          var nt = box.querySelector('[data-ai-pdp-price-original]');
          if (!nt || nt.style.visibility === 'hidden' || nt.style.display === 'none') nt = box.querySelector('[data-ai-pdp-price-reveal]');
          if (!nt || nt.style.display === 'none') nt = box.querySelector('.price') || box;
          box.__vaultPriceAnimation = nt.animate(
            [{ opacity: 0, filter: 'blur(10px)', transform: 'translateY(6px)' }, { opacity: 1, filter: 'blur(0)', transform: 'none' }],
            { duration: 900, easing: 'cubic-bezier(.2,.7,.2,1)' }
          );
          box.__vaultPriceAnimation.currentTime = t;
        }
        return;
      }
      if (running) running.cancel();
      if (!after) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !box.animate) return;
      var target = box.querySelector('[data-ai-pdp-price-original]');
      if (!target || target.style.visibility === 'hidden' || target.style.display === 'none') target = box.querySelector('[data-ai-pdp-price-reveal]');
      if (!target || target.style.display === 'none') target = box.querySelector('.price') || box;
      box.__vaultPriceAnimation = target.animate(
        [{ opacity: 0, filter: 'blur(10px)', transform: 'translateY(6px)' }, { opacity: 1, filter: 'blur(0)', transform: 'none' }],
        { duration: 900, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
    }
  };
  /* Shared listeners live once per document; section work is released on removal. */
  if (!window.vaultInit.scope) {
    var scopes = new Set(), hubs = new Map();
    function dispose(scope) {
      if (!scope.alive) return;
      scope.alive = false;
      Array.from(scope.cleanups).reverse().forEach(function (fn) { fn(); });
      scope.cleanups.clear();
      scopes.delete(scope);
      delete scope.root.__vaultPhases;
    }
    function sectionScope(root, name) {
      for (var existing of scopes) if (existing.root === root && existing.name === name) return existing;
      var scope = { root: root, name: name, alive: true, cleanups: new Set() };
      scopes.add(scope);
      scope.cleanup = function (fn) { scope.cleanups.add(fn); };
      scope.on = function (site, target, type, fn, options) {
        if (!scope.alive) return;
        if ((target === document && type === 'DOMContentLoaded' && document.readyState !== 'loading') ||
            (target === window && type === 'load' && document.readyState === 'complete')) {
          scope.timeout(function () { fn.call(target, new Event(type)); }, 0);
          return;
        }
        var capture = options === true || !!(options && options.capture);
        if (target === document || target === window) {
          var key = name + ':' + site + ':' + (target === window ? 'w:' : 'd:') + type + ':' + capture + ':' + !!(options && options.passive);
          var hub = hubs.get(key);
          if (!hub) {
            hub = new Set(); hubs.set(key, hub);
            target.addEventListener(type, function (event) {
              var stopped = false, stop = event.stopImmediatePropagation;
              event.stopImmediatePropagation = function () { stopped = true; stop.call(event); };
              try {
                for (var item of Array.from(hub)) {
                  if (!item.scope.root.isConnected) { dispose(item.scope); continue; }
                  if (!item.scope.alive) continue;
                  if (item.once) { hub.delete(item); item.scope.cleanups.delete(item.cleanup); }
                  item.fn.call(target, event);
                  if (stopped) break;
                }
              } finally { event.stopImmediatePropagation = stop; }
            }, { capture: capture, passive: !!(options && options.passive) });
          }
          var item = { scope: scope, target: target, type: type, capture: capture, fn: fn, once: !!(options && options.once) };
          hub.add(item);
          item.cleanup = function () { hub.delete(item); };
          scope.cleanup(item.cleanup);
        } else {
          target.addEventListener(type, fn, options);
          scope.cleanup(function () { target.removeEventListener(type, fn, options); });
        }
      };
      scope.off = function (target, type, fn, options) {
        var capture = options === true || !!(options && options.capture);
        hubs.forEach(function (hub) {
          hub.forEach(function (item) {
            if (item.scope === scope && item.target === target && item.type === type && item.capture === capture && item.fn === fn) {
              hub.delete(item); scope.cleanups.delete(item.cleanup);
            }
          });
        });
        target.removeEventListener(type, fn, options);
      };
      var jobs = new Map();
      scope.cleanup(function () { jobs.forEach(function (cancel, id) { cancel(id); }); jobs.clear(); });
      function schedule(fn, ms, interval, frame) {
        if (!scope.alive) return 0;
        var cancel = frame ? cancelAnimationFrame : interval ? clearInterval : clearTimeout;
        var run = function (time) {
          if (!interval) jobs.delete(id);
          if (!scope.alive || !root.isConnected) { if (interval) dispose(scope); return; }
          fn(time);
        };
        var id = frame ? requestAnimationFrame(run) : interval ? setInterval(run, ms) : setTimeout(run, ms);
        jobs.set(id, cancel);
        return id;
      }
      scope.timeout = function (fn, ms) { return schedule(fn, ms, false, false); };
      scope.interval = function (fn, ms) { return schedule(fn, ms, true, false); };
      scope.frame = function (fn) { return schedule(fn, 0, false, true); };
      scope.clear = function (id) { var cancel = jobs.get(id); if (cancel) cancel(id); jobs.delete(id); };
      scope.observe = function (observer) { scope.cleanup(function () { observer.disconnect(); }); return observer; };
      return scope;
    }
    sectionScope.prune = function () { scopes.forEach(function (scope) { if (!scope.root.isConnected) dispose(scope); }); };
    sectionScope.replace = function (root, name) {
      scopes.forEach(function (scope) { if (scope.root === root && scope.name === name) dispose(scope); });
      return sectionScope(root, name);
    };
    sectionScope.unload = function (node) {
      scopes.forEach(function (scope) {
        if (scope.root !== document.documentElement && (scope.root === node || node.contains(scope.root) || scope.root.contains(node))) dispose(scope);
      });
    };
    window.vaultInit.scope = sectionScope;
  }

  function byId(root, id) { return root.id === id ? root : root.querySelector('[id="' + id + '"]'); }
  function variantList(root) {
    var product = root.matches('product-info') ? root : root.querySelector('product-info');
    return (product && product.__vaultVariants) || (window.Shopify && Array.isArray(window.Shopify.variants) ? window.Shopify.variants : []);
  }
  var shared = new Set(["legacy-toggle", "payment-panel", "payment-motion", "legacy-panel"]), installed = new Set();
  var phases = {
    "gallery-loop": function (root, config, scope) {

  // Endless product gallery without copies. When the gallery rests, the photos are re-ordered
  // so the current one sits in the middle with neighbours on both sides (… last, first, 2 …).
  // Where side photos show faintly, the last photo is hidden while the first photo is showing.
  window.vaultGalleryLoop = window.vaultGalleryLoop || function (swiper) {
    // Galleries using Swiper's own loop (phones) don't need this.
    if (!swiper || swiper.vaultLoop || !swiper.wrapperEl || swiper.params.loop) return;
    swiper.vaultLoop = true;
    const first = [...swiper.slides];
    if (first.every(slide => slide.dataset.loopIndex)) first.sort((a, b) => a.dataset.loopIndex - b.dataset.loopIndex);
    else first.forEach((slide, index) => { slide.dataset.loopIndex = index; });
    swiper.vaultPhotos = first;
    // A style gallery (assets/vault-picker.js) swaps swiper.vaultPhotos and turns the loop off (vaultLoopOff).
    function hideSizeChart() {
      const photos = swiper.vaultPhotos, count = photos.length;
      const showsSides = swiper.params.slidesPerView === 'auto';
      photos.forEach(slide => slide.classList.remove('vault-ghost-hidden'));
      if (swiper.vaultLoopOff) return;
      if (showsSides && count > 2 && swiper.slides[swiper.activeIndex] === photos[0]) photos[count - 1].classList.add('vault-ghost-hidden');
    }
    function arrange() {
      const photos = swiper.vaultPhotos, count = photos.length;
      if (swiper.vaultLoopOff) { hideSizeChart(); return; }
      const active = swiper.slides[swiper.activeIndex];
      // Only re-order photos that have real sizes; an unloaded or hidden gallery stays as it is.
      if (count > 2 && active && photos.every(slide => slide.offsetWidth > 0)) {
        const start = (Number(active.dataset.loopIndex) - Math.floor((count - 1) / 2) + count) % count;
        const order = photos.map((slide, index) => photos[(start + index) % count]);
        if (order.some((slide, index) => swiper.slides[index] !== slide)) {
          order.forEach(slide => swiper.wrapperEl.appendChild(slide));
          swiper.update();
          swiper.slideTo(order.indexOf(active), 0, false);
          if (swiper.navigation && swiper.navigation.update) swiper.navigation.update();
        }
      }
      hideSizeChart();
    }
    swiper.on('slideChange', hideSizeChart);
    swiper.on('slideChangeTransitionEnd', arrange);
    arrange();
  };

    },
    "desktop-gallery": function (root, config, scope) {

scope.on('desktop-gallery.0', document, 'DOMContentLoaded', function() {
  const gallery = root.querySelector(`#Slider-Gallery-${config.sectionId}-main`);

  if (!gallery || typeof Swiper === 'undefined') return;

  const galleryWrapper =
    gallery.closest('.swiper-container-wrapper-gallery') ||
    root.querySelector('.swiper-container-wrapper-gallery');
  const productSection = byId(root, `MainProduct-${config.sectionId}`);
  const arrowWrapper = productSection
    ? productSection.querySelector('.swiper_slider_arrows-gallery-desktop')
    : root.querySelector('.swiper_slider_arrows-gallery-desktop');
  const nextButton = arrowWrapper
    ? arrowWrapper.querySelector('.swiper-button-next-gallery')
    : null;
  const previousButton = arrowWrapper
    ? arrowWrapper.querySelector('.swiper-button-prev-gallery')
    : null;

  if (
    !galleryWrapper ||
    !arrowWrapper ||
    !nextButton ||
    !previousButton ||
    gallery.dataset.desktopGalleryReady === 'true'
  ) return;

  gallery.dataset.desktopGalleryReady = 'true';
  scope.cleanup(function () { delete gallery.dataset.desktopGalleryReady; if (swiper && swiper.destroy) swiper.destroy(true, true); });

  const images = galleryWrapper.querySelectorAll('img');
  const desktopView = window.matchMedia('(min-width: 990px)');
  const arrowButtons = [previousButton, nextButton];
  const arrowHideTimers = new Map();
  const proximityPadding = 70;
  let imagesLoaded = 0;
  let swiperStarted = false;
  let swiper = null;
  let fallbackTimer = 0;
  let updateFrame = 0;
  let proximityFrame = 0;
  let pendingPointerX = 0;
  let pendingPointerY = 0;
  let suppressClickUntil = 0;

  function requestSwiperUpdate() {
    if (!swiper || updateFrame) return;

    updateFrame = scope.frame(function() {
      updateFrame = 0;
      swiper.update();
      updateNavigationState(swiper);
    });
  }

  function updateSlideOpacity(swiperInstance) {
    const slides = swiperInstance.slides;
    const activeIndex = swiperInstance.activeIndex;

    slides.forEach(function(slide, index) {
      if (index === activeIndex) {
        slide.style.opacity = '1';
        slide.style.zIndex = '2';
        slide.style.transform = 'scale(1)';
      } else {
        slide.style.opacity = '0.2';
        slide.style.zIndex = '1';
        slide.style.transform = 'scale(0.95)';
      }
    });
  }

  function updateNavigationState(swiperInstance) {
    // The gallery loops, so neither arrow is ever disabled.
    const loops = Boolean(swiperInstance.vaultLoop);
    const atBeginning = !loops && swiperInstance.isBeginning;
    const atEnd = !loops && swiperInstance.isEnd;

    previousButton.classList.toggle('swiper-button-disabled', atBeginning);
    nextButton.classList.toggle('swiper-button-disabled', atEnd);
    previousButton.setAttribute('aria-disabled', String(atBeginning));
    nextButton.setAttribute('aria-disabled', String(atEnd));
  }

  function clearArrowHideTimer(button) {
    const timer = arrowHideTimers.get(button);

    if (timer) {
      scope.clear(timer);
      arrowHideTimers.delete(button);
    }
  }

  function setArrowVisible(button, visible) {
    if (!button) return;

    button.classList.toggle('gallery-arrow-hidden', !visible);
  }

  function scheduleArrowHide(button) {
    if (!desktopView.matches || !button) return;

    clearArrowHideTimer(button);

    const timer = scope.timeout(function() {
      setArrowVisible(button, false);
      arrowHideTimers.delete(button);
    }, 2000);

    arrowHideTimers.set(button, timer);
  }

  function showArrow(button, hideAfterDelay) {
    if (!button || !desktopView.matches) return;

    setArrowVisible(button, true);

    if (hideAfterDelay) {
      scheduleArrowHide(button);
    } else {
      clearArrowHideTimer(button);
    }
  }

  function scheduleVisibleArrowsToHide() {
    arrowButtons.forEach(function(button) {
      if (!button.classList.contains('gallery-arrow-hidden')) {
        scheduleArrowHide(button);
      }
    });
  }

  function getButtonForDirection(direction) {
    if (direction < 0) return previousButton;
    if (direction > 0) return nextButton;
    return null;
  }

  function pointIsNearButton(x, y, button, padding) {
    const rect = button.getBoundingClientRect();

    return (
      x >= rect.left - padding &&
      x <= rect.right + padding &&
      y >= rect.top - padding &&
      y <= rect.bottom + padding
    );
  }

  function getClickedArrowButton(event) {
    const target = event.target instanceof Element
      ? event.target
      : null;

    if (!target) return null;

    return target.closest(
      '.swiper-button-prev-gallery, .swiper-button-next-gallery'
    );
  }

  function getPointerDirection(event) {
    const target = event.target instanceof Element
      ? event.target
      : null;

    if (target && target.closest('.swiper-button-prev-gallery')) {
      return -1;
    }

    if (target && target.closest('.swiper-button-next-gallery')) {
      return 1;
    }

    const wrapperRect = arrowWrapper.getBoundingClientRect();
    const galleryRect = gallery.getBoundingClientRect();
    const verticalPadding = Math.min(
      120,
      Math.max(60, galleryRect.height * 0.12)
    );

    if (
      event.clientY < galleryRect.top - verticalPadding ||
      event.clientY > galleryRect.bottom + verticalPadding ||
      event.clientX < wrapperRect.left ||
      event.clientX > wrapperRect.right ||
      wrapperRect.width === 0
    ) {
      return 0;
    }

    const hitZoneWidth = Math.min(
      240,
      Math.max(120, wrapperRect.width * 0.44),
      wrapperRect.width * 0.46
    );
    const pointerPosition =
      event.clientX - wrapperRect.left;

    if (pointerPosition <= hitZoneWidth) {
      return -1;
    }

    if (
      pointerPosition >=
      wrapperRect.width - hitZoneWidth
    ) {
      return 1;
    }

    return 0;
  }

  function moveGallery(direction) {
    if (!swiper || direction === 0) return;

    // Loop past either end: last photo -> first, first photo -> last.
    if (direction < 0) {
      if (swiper.isBeginning) swiper.slideTo(swiper.slides.length - 1, 220, true);
      else swiper.slidePrev(220, true);
    } else if (swiper.isEnd) {
      swiper.slideTo(0, 220, true);
    } else {
      swiper.slideNext(220, true);
    }
  }

  function initializeSwiper() {
    if (swiperStarted) {
      requestSwiperUpdate();
      return;
    }

    swiperStarted = true;
    scope.clear(fallbackTimer);

    swiper = new Swiper(gallery, {
      direction: 'horizontal',
      loop: false,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      grabCursor: true,
      speed: 320,
      longSwipesRatio: 0.15, // VAULT: a mouse drag of ~15% of the photo is enough (Swiper's default needs half)
      preventInteractionOnTransition: false,

      breakpoints: {
        320: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 0,
        }
      },

      on: {
        init: function() {
          updateSlideOpacity(this);
          updateNavigationState(this);
          galleryWrapper.classList.add('swiper-initialized');
          arrowWrapper.classList.remove('gallery-arrows-hidden');

          arrowButtons.forEach(function(button) {
            showArrow(button, false);
          });
        },
        slideChange: function() {
          updateSlideOpacity(this);
          updateNavigationState(this);
        },
        slideChangeTransitionEnd: function() {
          updateSlideOpacity(this);
          updateNavigationState(this);
        }
      }
    });
    startLoop();
  }

  function startLoop() {
    if (!swiper || !window.vaultGalleryLoop) return;
    window.vaultGalleryLoop(swiper);
    if (window.vaultHeroSlide) window.vaultHeroSlide(swiper);
    swiper.on('slideChangeTransitionEnd', function() { updateNavigationState(swiper); });
    updateNavigationState(swiper);
  }

  function imageLoaded() {
    imagesLoaded++;
    requestSwiperUpdate();

    if (imagesLoaded === images.length) {
      initializeSwiper();
    }
  }

  if (images.length === 0) {
    initializeSwiper();
  } else {
    images.forEach(function(image) {
      if (image.complete) {
        imagesLoaded++;
      } else {
        scope.on('desktop-gallery.1', image, 'load', imageLoaded, { once: true });
        scope.on('desktop-gallery.2', image, 'error', imageLoaded, { once: true });
      }
    });

    // Start swiping right away; photos that finish loading later just refresh the sizes.
    initializeSwiper();
  }

  var galleryDrag = null;
  scope.on('desktop-gallery.3', arrowWrapper, 'pointerdown', function(event) {
    if (!desktopView.matches || !swiper) return;

    const direction = getPointerDirection(event);

    // VAULT: a mouse press on the photo (not an arrow) is handed to Swiper's own drag – the same smooth swipe
    // as a finger. A press that doesn't move is still a click: it steps on release (edges only).
    if (event.pointerType === 'mouse' && event.button === 0 && !getClickedArrowButton(event)) {
      const gr = swiper.el.getBoundingClientRect();
      if (event.clientY >= gr.top && event.clientY <= gr.bottom) {
        event.preventDefault();
        event.stopPropagation();
        galleryDrag = { x: event.clientX, dir: direction };
        arrowWrapper.classList.add('vault-g-dragging');
        (swiper.wrapperEl || swiper.el).dispatchEvent(new PointerEvent('pointerdown', {
          bubbles: true, cancelable: true, clientX: event.clientX, clientY: event.clientY, screenX: event.screenX, screenY: event.screenY,
          pointerId: event.pointerId, pointerType: 'mouse', button: 0, buttons: 1, isPrimary: true
        }));
        return;
      }
    }

    if (direction === 0) return;

    const clickedArrowButton =
      getClickedArrowButton(event);

    event.preventDefault();
    event.stopPropagation();

    suppressClickUntil =
      window.performance.now() + 700;

    if (clickedArrowButton) {
      showArrow(clickedArrowButton, true);
    }

    moveGallery(direction);
  }, true);

  function endGalleryDrag(event) {
    if (!galleryDrag || !swiper) return;
    var d = galleryDrag;
    galleryDrag = null;
    arrowWrapper.classList.remove('vault-g-dragging');
    var dx = (event && event.clientX != null ? event.clientX : d.x) - d.x;
    suppressClickUntil = window.performance.now() + 400;
    if (Math.abs(dx) < 6 && d.dir) moveGallery(d.dir); // a click, not a drag
  }
  scope.on('desktop-gallery.4', window, 'pointerup', endGalleryDrag, true);
  scope.on('desktop-gallery.5', window, 'pointercancel', endGalleryDrag, true);

  // VAULT: one arrow at a time – the side the mouse is on: right half → right arrow fades in, left half → left
  scope.on('desktop-gallery.6', arrowWrapper, 'pointermove', function(event) {
    if (!desktopView.matches || event.pointerType !== 'mouse' || galleryDrag) return;
    var wr = arrowWrapper.getBoundingClientRect();
    var right = event.clientX > wr.left + wr.width / 2;
    var on = right ? nextButton : previousButton, off = right ? previousButton : nextButton;
    clearArrowHideTimer(on); setArrowVisible(on, true);
    setArrowVisible(off, false);
  });
  scope.on('desktop-gallery.7', arrowWrapper, 'pointerleave', function() {
    if (!desktopView.matches) return;
    setArrowVisible(nextButton, false);
    setArrowVisible(previousButton, false);
  });

  scope.on('desktop-gallery.8', arrowWrapper, 'click', function(event) {
    if (!desktopView.matches || !swiper) return;

    const direction = getPointerDirection(event);

    if (direction === 0) return;

    const clickedArrowButton =
      getClickedArrowButton(event);

    event.preventDefault();
    event.stopImmediatePropagation();

    if (
      window.performance.now() >
      suppressClickUntil
    ) {
      if (clickedArrowButton) {
        showArrow(clickedArrowButton, true);
      }

      moveGallery(direction);
    }
  }, true);

  scope.on('desktop-gallery.9', arrowWrapper, 'pointermove', function(event) {
    if (
      !desktopView.matches ||
      (
        !previousButton.classList.contains('gallery-arrow-hidden') &&
        !nextButton.classList.contains('gallery-arrow-hidden')
      )
    ) {
      return;
    }

    pendingPointerX = event.clientX;
    pendingPointerY = event.clientY;

    if (proximityFrame) return;

    proximityFrame = scope.frame(function() {
      proximityFrame = 0;

      if (
        previousButton.classList.contains('gallery-arrow-hidden') &&
        pointIsNearButton(
          pendingPointerX,
          pendingPointerY,
          previousButton,
          proximityPadding
        )
      ) {
        showArrow(previousButton, true);
      }

      if (
        nextButton.classList.contains('gallery-arrow-hidden') &&
        pointIsNearButton(
          pendingPointerX,
          pendingPointerY,
          nextButton,
          proximityPadding
        )
      ) {
        showArrow(nextButton, true);
      }
    });
  }, { passive: true });

  scope.on('desktop-gallery.10', document, 'pointerdown', function() {
    if (!desktopView.matches) return;

    scheduleVisibleArrowsToHide();
  }, { capture: true, passive: true });

  scope.on('desktop-gallery.11', document, 'keydown', function(event) {
    if (
      !desktopView.matches ||
      !swiper ||
      event.defaultPrevented ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')
    ) {
      return;
    }

    const activeElement = document.activeElement;
    const isTyping = activeElement && activeElement.closest(
      'input, textarea, select, button, [contenteditable="true"]'
    );

    if (
      isTyping ||
      document.querySelector(
        'dialog[open], product-modal[open], .product-media-modal[open]'
      )
    ) {
      return;
    }

    const galleryRect = gallery.getBoundingClientRect();
    const galleryIsVisible =
      galleryRect.bottom > 0 && galleryRect.top < window.innerHeight;

    if (!galleryIsVisible) return;

    event.preventDefault();

    if (event.key === 'ArrowLeft') {
      moveGallery(-1);
    } else {
      moveGallery(1);
    }
  });

  function handleDesktopChange() {
    arrowButtons.forEach(function(button) {
      showArrow(button, false);
    });

    arrowWrapper.classList.remove('gallery-arrows-hidden');
    requestSwiperUpdate();
  }

  if (desktopView.addEventListener) {
    scope.on('desktop-gallery.12', desktopView, 'change', handleDesktopChange);
  } else {
    desktopView.addListener(handleDesktopChange);
    scope.cleanup(function () { desktopView.removeListener(handleDesktopChange); });
  }

  scope.on('desktop-gallery.13', window, 'resize', requestSwiperUpdate, { passive: true });
});

    },
    "info-position": function (root, config, scope) {

(function () {
  function initProductInfoStopShift() {
    var info = byId(root, 
      `ProductInfo-${config.sectionId}`
    );

    var wrapper = info
      ? info.closest('.product__info-wrapper')
      : null;

    if (
      !info ||
      !wrapper ||
      wrapper.dataset.stopShiftReady === 'true'
    ) return;

    wrapper.dataset.stopShiftReady = 'true';
    scope.cleanup(function () { delete wrapper.dataset.stopShiftReady; });

    var desktop = window.matchMedia(
      '(min-width: 991px)'
    );

    var frame = null;

    function updateProductInfoStopShift() {
      frame = null;

      if (!info.isConnected) return;

      if (!desktop.matches) {
        info.style.removeProperty(
          '--product-info-stop-shift'
        );

        return;
      }

      var rootFontSize = parseFloat(
        window.getComputedStyle(
          document.documentElement
        ).fontSize
      ) || 10;

      var stickyTop = 12 * rootFontSize;
      var maximumShift = 6.4 * rootFontSize;

      // 6.4rem was tuned when "ITEM/S AVAILABLE LEFT" was the last thing in the column. Now the WORN BY box
      // (VIEW THEIR LOOKS) is last, so measure instead: stop where its bottom lines up with I NEED ASSURANCE.
      var worn = info.querySelector('.vip-worn');
      var assure = wrapper.parentElement && Array.prototype.find.call(
        wrapper.parentElement.querySelectorAll('a, button'),
        function (el) { return el.offsetHeight && /NEED ASSURANCE/i.test(el.textContent); }
      );
      if (worn && worn.offsetHeight && assure) {
        var current = parseFloat(info.style.getPropertyValue('--product-info-stop-shift')) || 0;
        // Signed: down when the column is shorter than the left side, up when it's taller (options open).
        maximumShift = current - (worn.getBoundingClientRect().bottom - assure.getBoundingClientRect().bottom);
      }

      var wrapperTop = wrapper
        .getBoundingClientRect()
        .top;

      // Ease in as the column stops being pinned: 0 while pinned, reaching the full alignment shift
      // (either direction) once the page has scrolled that far past.
      var travel = Math.max(0, stickyTop - wrapperTop);
      var requiredShift = maximumShift < 0
        ? -Math.min(-maximumShift, travel)
        : Math.min(maximumShift, travel);

      info.style.setProperty(
        '--product-info-stop-shift',
        requiredShift + 'px'
      );
    }

    function scheduleProductInfoUpdate() {
      if (frame !== null) return;

      frame = scope.frame(
        updateProductInfoStopShift
      );
    }

    scope.on('info-position.0', window, 
      'scroll',
      scheduleProductInfoUpdate,
      { passive: true }
    );

    scope.on('info-position.1', window, 
      'resize',
      scheduleProductInfoUpdate,
      { passive: true }
    );

    if (desktop.addEventListener) {
      scope.on('info-position.2', desktop, 
        'change',
        scheduleProductInfoUpdate
      );
    } else {
      desktop.addListener(
        scheduleProductInfoUpdate
      );
      scope.cleanup(function () { desktop.removeListener(scheduleProductInfoUpdate); });
    }

    scheduleProductInfoUpdate();
  }

  if (document.readyState === 'loading') {
    scope.on('info-position.3', document, 
      'DOMContentLoaded',
      initProductInfoStopShift,
      { once: true }
    );
  } else {
    initProductInfoStopShift();
  }

  scope.on('info-position.4', document, 
    'shopify:section:load',
    initProductInfoStopShift
  );
})();

    },
    "legacy-toggle": function (root, config, scope) {

  // Delegated handler: handle ONLY legacy markup; ignore .dp to prevent double toggle
  scope.on('legacy-toggle.0', document, 'click', function (e) {
    const btn = e.target.closest('.accordion-btn');
    if (!btn) return;

    // If this button is inside the new DP wrapper, let the DP script handle it.
    if (btn.closest('.dp')) return;

    const wrap =
      btn.closest('.down_payment_link_main') ||
      btn.parentElement;

    if (!wrap) return;

    const content = wrap.querySelector('.accordion-content');

    if (content) {
      e.preventDefault();
      content.classList.toggle('active');
    }
  }, true);

    },
    "soldout-selects": function (root, config, scope) {

(function () {
  // Stable root covers both left and right pickers + mobile

  let lastVariantAvailable = null;

  function selects() {
    return root.querySelectorAll('.product-form__input--dropdown .select__select');
  }

  function selectedTextIsSoldOut(sel) {
    const opt = sel && sel.options ? sel.options[sel.selectedIndex] : null;
    return !!(opt && /sold\s*out/i.test((opt.text || '').trim()));
  }

  function apply() {
  // Dim only the dropdown whose selected option is SOLD OUT
  Array.from(selects()).forEach(sel => {
    const opt = sel && sel.options ? sel.options[sel.selectedIndex] : null;
    const so  = !!(opt && (/sold\s*out/i.test((opt.text || '').trim()) || opt.disabled));
    sel.style.opacity = so ? '0.3' : '';
    const wrap = sel.closest('.select');
    if (wrap) wrap.classList.toggle('is-sold-out', so);
  });

  // No global flag — other dropdowns stay full opacity
  if (root.hasAttribute('data-soldout')) root.removeAttribute('data-soldout');
}

  // After DOM swaps, run a few passes so it sticks
  function afterSwap() {
    scope.frame(() => {
      apply();
      scope.timeout(apply, 80);
      scope.timeout(apply, 250);
      scope.timeout(apply, 600);
    });
  }

  // React to variant change; just re-apply dimming
scope.on('soldout-selects.0', document, 'variant:change', () => {
  afterSwap();
}, true);

  // User changes a dropdown
  scope.on('soldout-selects.1', document, 'change', (e) => {
    if (e.target && e.target.matches('.product-form__input--dropdown .select__select')) afterSwap();
  }, true);

  // Section reloads / dynamic updates
  scope.on('soldout-selects.2', document, 'shopify:section:load', afterSwap);

  if ('MutationObserver' in window) {
    scope.observe(new MutationObserver(afterSwap)).observe(root, { childList: true, subtree: true });
  }

  // First paint
  if (document.readyState === 'loading') {
    scope.on('soldout-selects.3', document, 'DOMContentLoaded', afterSwap);
  } else {
    afterSwap();
  }
})();

    },
    "title": function (root, config, scope) {

                      (function () {
                        var m = config.titles;
                        var s = (location.search.match(/[?&]style=([^&#]+)/) || [])[1];
                        if (!s || !m[s]) return;
                        var box = config.node.parentNode;
                        if (m[s][0]) box.querySelectorAll('h1:not(.brands_name_above), h2.h1').forEach(function (e) {
                          e.dataset.vaultName = e.textContent.trim();
                          e.textContent = m[s][0];
                        });
                        if (m[s][1]) box.querySelectorAll('.brands_name_above').forEach(function (e) {
                          e.dataset.vaultName = e.textContent.trim();
                          e.textContent = m[s][1];
                        });
                      })();
                    
    },
    "price-schedule": function (root, config, scope) {
                      var priceScope = root.querySelector('[data-ai-pdp-price-schedule]');
                      if (!priceScope || priceScope.__vaultSchedule) return;
                      priceScope.__vaultSchedule = true;
                      scope = window.vaultInit.scope(priceScope, 'ProductPrice');

                      (function () {

                        // Metafield is TRUE, so scheduling is ALWAYS ON for this product.
                        var schedulingOn = true;

                        var outsideMode = config.price_outside_mode; // normal | reveal | hide
                        var template = config.price_reveal_template;
                        if (!outsideMode) outsideMode = "reveal";
                        if (!template) template = "WILL BE REVEALED ON {next_start}";

                        var weeklyStartDay = config.price_weekly_start_day;
                        var weeklyStartTime = config.price_weekly_start_time;
                        var weeklyEndDay = config.price_weekly_end_day;
                        var weeklyEndTime = config.price_weekly_end_time;

                        var useCustom = config.price_schedule_use_custom;
                        var customStartText = config.price_custom_start;
                        var customEndText   = config.price_custom_end;

                        var graceDays = config.price_grace_days;
                        graceDays = parseInt(graceDays, 10);
                        if (isNaN(graceDays) || graceDays < 0) graceDays = 0;
                        if (graceDays > 30) graceDays = 30;

                        var CUSTOM_PLACEHOLDER = "1970-01-01 00:00";
                        if (customStartText === CUSTOM_PLACEHOLDER) customStartText = "";
                        if (customEndText === CUSTOM_PLACEHOLDER) customEndText = "";

                        var DAY_MS = 86400000;
                        var MIN_MS = 60000;
                        var PHT_OFFSET_MS = 8 * 60 * 60 * 1000;

                        function dayToNum(d) {
                          var map = { sun:0, mon:1, tue:2, wed:3, thu:4, fri:5, sat:6 };
                          return map[(d || "").toLowerCase()] ?? 6;
                        }

                        function parseTimeHHMM(str, fallback) {
                          var s = (str || "").trim();
                          var m = s.match(/^(\d{1,2}):(\d{2})$/);
                          if (!m) return fallback;
                          var hh = parseInt(m[1], 10);
                          var mm = parseInt(m[2], 10);
                          if (isNaN(hh) || isNaN(mm) || hh < 0 || hh > 23 || mm < 0 || mm > 59) return fallback;
                          return (hh * 60) + mm;
                        }

                        function parseCustomDateTime(str) {
                          var s = (str || "").trim();
                          var m = s.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})$/);
                          if (!m) return null;
                          var Y = parseInt(m[1], 10);
                          var Mo = parseInt(m[2], 10) - 1;
                          var D = parseInt(m[3], 10);
                          var H = parseInt(m[4], 10);
                          var Mi = parseInt(m[5], 10);
                          if ([Y,Mo,D,H,Mi].some(function(n){ return isNaN(n); })) return null;
                          return Date.UTC(Y, Mo, D, H, Mi);
                        }

                        function pad2(n){ return (n < 10 ? "0" : "") + n; }

                        function formatNextStartPHT(msShifted) {
                          if (!msShifted) return "";
                          var d = new Date(msShifted);
                          var days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
                          var dow = days[d.getUTCDay()];
                          var hh = d.getUTCHours();
                          var mm = d.getUTCMinutes();
                          var ampm = (hh >= 12) ? "PM" : "AM";
                          var h12 = hh % 12; if (h12 === 0) h12 = 12;
                          return dow + " " + h12 + ":" + pad2(mm) + " " + ampm + " (PHT)";
                        }

                        function escapeHtml(str) {
                          return String(str || "")
                            .replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/"/g, "&quot;")
                            .replace(/'/g, "&#039;");
                        }

                        function applyTemplate(tpl, nextStartText) {
                          var t = String(tpl || "");
                          return t.split("{next_start}").join(nextStartText);
                        }

                        function computeState(nowShifted) {
                          var nowDate = new Date(nowShifted);

                          var startDayNum = dayToNum(weeklyStartDay);
                          var endDayNum = dayToNum(weeklyEndDay);
                          var startMin = parseTimeHHMM(weeklyStartTime, (20*60 + 15));
                          var endMin = parseTimeHHMM(weeklyEndTime, (23*60 + 59));

                          var Y = nowDate.getUTCFullYear();
                          var M = nowDate.getUTCMonth();
                          var D = nowDate.getUTCDate();
                          var dowNow = nowDate.getUTCDay();

                          var todayMidnight = Date.UTC(Y, M, D);
                          var startOfWeek = todayMidnight - (dowNow * DAY_MS);

                          var weeklyStartThis = startOfWeek + (startDayNum * DAY_MS) + (startMin * MIN_MS);
                          var weeklyEndThis = startOfWeek + (endDayNum * DAY_MS) + (endMin * MIN_MS);
                          if (weeklyEndThis <= weeklyStartThis) weeklyEndThis += (7 * DAY_MS);

                          var weeklyStartLast = weeklyStartThis - (7 * DAY_MS);
                          var weeklyEndLast = weeklyEndThis - (7 * DAY_MS);

                          var insideWeekly =
                            (nowShifted >= weeklyStartThis && nowShifted <= weeklyEndThis) ||
                            (nowShifted >= weeklyStartLast && nowShifted <= weeklyEndLast);

                          var nextWeeklyStart = (nowShifted < weeklyStartThis) ? weeklyStartThis : (weeklyStartThis + 7 * DAY_MS);

                          var customStart = useCustom ? parseCustomDateTime(customStartText) : null;
                          var customEnd   = useCustom ? parseCustomDateTime(customEndText) : null;
                          var customValid = !!(customStart && customEnd && customEnd > customStart);

                          var insideWindow = insideWeekly;
                          var nextStartMs = nextWeeklyStart;

                          if (useCustom && customValid) {
                            if (nowShifted <= customEnd) {
                              insideWindow = (nowShifted >= customStart && nowShifted <= customEnd);
                              nextStartMs = (nowShifted < customStart) ? customStart : nextWeeklyStart;
                            } else if (config.price_custom_only) {
                              /* Drop schedule: after the drop closes the price stays hidden (no weekly fallback). */
                              return { insideWindow: false, nextStartMs: null, closed: true };
                            } else {
                              insideWindow = insideWeekly;
                              nextStartMs = nextWeeklyStart;
                            }
                          }

                          // Grace period after the window ends
                          if (!insideWindow && graceDays > 0) {
                            var lastWeeklyEnd = (nowShifted >= weeklyEndThis) ? weeklyEndThis : weeklyEndLast;
                            var lastEndMs = lastWeeklyEnd;
                            if (customValid && customEnd && nowShifted >= customEnd) {
                              lastEndMs = Math.max(lastEndMs, customEnd);
                            }
                            if (lastEndMs && nowShifted <= (lastEndMs + (graceDays * DAY_MS))) {
                              insideWindow = true;
                            }
                          }

                          return { insideWindow: insideWindow, nextStartMs: nextStartMs };
                        }

                        var previousWindowState = null;

                        function apply() {
                          var nowShifted = Date.now() + PHT_OFFSET_MS;
                          var state = computeState(nowShifted);
                          var insideWindow = !!state.insideWindow;
                          var shouldAnimate = previousWindowState === false && insideWindow;

                          previousWindowState = insideWindow;

                          var roots = root.querySelectorAll(
                            `#price-${config.sectionId}, #price-mobile-${config.sectionId}`
                          );

                          roots.forEach(function(root) {
                            var original = root.querySelector('[data-ai-pdp-price-original]');
                            var reveal = root.querySelector('[data-ai-pdp-price-reveal]');
                            if (!original || !reveal) return;

                            var before = window.VaultPriceFade.read(root);
                            original.style.visibility = 'visible';

                            if (state.closed) {
                              original.style.display = '';
                              original.style.visibility = 'hidden';
                              reveal.style.display = 'none';
                              if (reveal.innerHTML) reveal.innerHTML = '';
                              return;
                            }

                            if (insideWindow || outsideMode === "normal") {
                              original.style.display = '';
                              reveal.style.display = 'none';

                              if (reveal.innerHTML) {
                                reveal.innerHTML = '';
                              }

                              if (shouldAnimate) window.VaultPriceFade.play(root, before);

                              return;
                            }

                            if (outsideMode === "hide") {
                              original.style.display = '';
                              original.style.visibility = 'hidden';
                              reveal.style.display = 'none';

                              if (reveal.innerHTML) {
                                reveal.innerHTML = '';
                              }

                              return;
                            }

                            var nextStartText = formatNextStartPHT(state.nextStartMs);
                            var msg = applyTemplate(template, nextStartText);
                            var revealMarkup =
                              '<span class="price-item price-item--regular">' +
                              escapeHtml(msg) +
                              '</span>';

                            original.style.display = '';
                            original.style.visibility = 'hidden';
                            reveal.style.display = '';

                            if (reveal.innerHTML !== revealMarkup) {
                              reveal.innerHTML = revealMarkup;
                            }
                          });
                        }

                        function runSoon(){
                          apply();
                          scope.timeout(apply, 80);
                        }

                        // Run immediately (so mobile sync copies the correct state)
                        runSoon();

                        function scheduleMinuteCheck() {
                          var delay = 60000 - (Date.now() % 60000) + 100;

                          scope.timeout(function() {
                            apply();
                            scheduleMinuteCheck();
                          }, delay);
                        }

                        scheduleMinuteCheck();

                        scope.on('price-schedule.0', document, 'visibilitychange', function() {
                          if (!document.hidden) apply();
                        });

                        scope.on('price-schedule.1', document, 'variant:change', runSoon, true);
                        scope.on('price-schedule.2', document, 'shopify:section:load', runSoon);
                        scope.on('price-schedule.drop', document, 'vault:drop-phase', runSoon);

                        var priceRoot = root.querySelector(`#price-${config.sectionId}`);
                        if (priceRoot && 'MutationObserver' in window) {
                          scope.observe(new MutationObserver(runSoon)).observe(priceRoot, { childList: true, subtree: true });
                        }
                      })();
                    
    },
    "community-videos": function (root, config, scope) {

       (function () {
         var communityHome = null;
         scope.cleanup(function () { if (communityHome) communityHome.parent.insertBefore(communityHome.el, communityHome.next); });

         function moveCommunityVideosLeft() {
           if (!window.matchMedia('(min-width: 991px)').matches) {
             if (communityHome && communityHome.el.parentElement !== communityHome.parent) {
               communityHome.parent.insertBefore(communityHome.el, communityHome.next);
             }
             return false;
           }

           var target = byId(root, 'ss-product-videos-left');
           if (!target) return false;

           var headings = document.querySelectorAll('[class*="video-heading-"]');

           for (var i = 0; i < headings.length; i++) {
             if (
               headings[i].textContent.trim().toUpperCase() !==
               'WORN BY OUR COMMUNITY'
             ) {
               continue;
             }

             var videoSection = headings[i].closest(
               'div[id^="ss-product-video-"]'
             );

             if (videoSection) {
               if (videoSection.parentElement !== target) {
                 if (!communityHome) {
                   communityHome = {
                     el: videoSection,
                     parent: videoSection.parentElement,
                     next: videoSection.nextSibling
                   };
                 }
                 target.appendChild(videoSection);
               }

               return true;
             }
           }

           return false;
         }

         var observer = scope.observe(new MutationObserver(function () {
           moveCommunityVideosLeft();
         }));

         var productRoot =
           byId(root, `MainProduct-${config.sectionId}`);

         if (productRoot) {
           observer.observe(productRoot, {
             childList: true,
             subtree: true
           });
         }

         if (document.readyState === 'loading') {
           scope.on('community-videos.0', document, 
             'DOMContentLoaded',
             moveCommunityVideosLeft
           );
         } else {
           moveCommunityVideosLeft();
         }

         scope.on('community-videos.1', window, 
           'load',
           moveCommunityVideosLeft,
           { once: true }
         );

         scope.timeout(moveCommunityVideosLeft, 3000);

         scope.on('community-videos.media', window.matchMedia('(min-width: 991px)'), 'change', moveCommunityVideosLeft);
       })();
     
    },
    "mobile-price": function (root, config, scope) {

                  /* Keep mobile price in sync with the main price */
                  (function(){
                    var initialized = false;
                    function syncPrices(){
                      var main = root.querySelector(`#price-${config.sectionId}`);
                      var mobile = root.querySelector(`#price-mobile-${config.sectionId}`);
                      if (!main || !mobile) return;

                      // Swap only the price. The Judge.me stars stay in place so their fade-in doesn't replay.
                      var badge = mobile.querySelector('.jdgm_widget_custom_widget');
                      /* R43 P1-1-07: variant:change fires on every swipe BEFORE the look's price arrives – copying the
                         unchanged main block rebuilt the phone price and replayed its zoom-blur on the OLD price (a faint
                         ₱4,550 came back, then ₱5,050 animated in). Same price already showing: leave it alone. */
                      var norm = function (t) { return String(t || '').replace(/\s+/g, ' ').trim(); };
                      var shown = Array.from(mobile.childNodes).filter(function (node) { return node !== badge; })
                        .map(function (node) { return node.textContent; }).join(' ');
                      if (norm(shown) === norm(main.textContent)) { initialized = true; return; }
                      var animate = initialized;
                      initialized = true;
                      var before = window.VaultPriceFade.read(mobile);
                      mobile.classList.add('vault-price-quiet');
                      if (!badge || badge.parentNode !== mobile) {
                        mobile.innerHTML = main.innerHTML;
                        if (animate) window.VaultPriceFade.play(mobile, before);
                        return;
                      }
                      Array.from(mobile.childNodes).forEach(function (node) {
                        if (node !== badge) node.remove();
                      });
                      badge.insertAdjacentHTML('beforebegin', main.innerHTML);
                      if (animate) window.VaultPriceFade.play(mobile, before);
                    }

                    scope.on('mobile-price.0', document, 'DOMContentLoaded', syncPrices);
                    scope.on('mobile-price.1', document, 'variant:change', syncPrices, true);
                    scope.on('mobile-price.2', document, 'shopify:section:load', syncPrices);

                    // If Shopify swaps price HTML, observe and resync
                    var mainBox = root.querySelector(`#price-${config.sectionId}`);
                    if (mainBox && 'MutationObserver' in window) {
                      scope.observe(new MutationObserver(syncPrices)).observe(mainBox, { childList: true, subtree: true });
                    }
                  })();
                
    },
    "payment-panel": function (root, config, scope) {

(function() {
  /* CSS overrides injected once:
     - NO underline on the trigger
     - Slight bottom gap when open (prevents overlap)
     - Ease-in-out + 1.2→1 zoom with 0→100% opacity on panel content
  */
  if (!window.__dpCSSNoUnderline) {
    const st = document.createElement('style');
    st.textContent = `
      .dp .accordion-btn { text-decoration: none !important; }
      .dp.is-open { margin-bottom: 16px; }
      .dp .accordion-content { will-change: transform, opacity; }
      .dp.is-open .accordion-content {
        transform-origin: top center;
        animation: dpZoomIn .24s ease-in-out;
      }
      @keyframes dpZoomIn {
        0% { opacity: 0; transform: scale(1.2); }
        100% { opacity: 1; transform: scale(1); }
      }
    `;
    document.head.appendChild(st);
    window.__dpCSSNoUnderline = true;
  }

  function closeDP(wrap){
    if (!wrap || !wrap.classList.contains('is-open')) return;
    const panel  = wrap.querySelector('.dp-panel');
    const toggle = wrap.querySelector('.js-dp-toggle');
    wrap.classList.remove('is-open');
    panel?.setAttribute('aria-hidden','true');
    if (toggle){
      toggle.setAttribute('aria-expanded','false');
      toggle.style.visibility = '';
      toggle.classList.remove('fade-out');
    }
  }

  scope.on('payment-panel.0', document, 'click', function(e) {
    const openBtn = e.target.closest('.js-dp-toggle');
    const closeBtn = e.target.closest('.js-dp-close');
    const igLink  = e.target.closest('.dp-ig');

    if (openBtn) {
      openBtn.classList.add('is-pressed');
      scope.timeout(() => openBtn.classList.remove('is-pressed'), 120);
    }

    if (openBtn || closeBtn) {
      e.preventDefault();
      const wrap   = (openBtn || closeBtn).closest('.dp');
      const panel  = wrap.querySelector('.dp-panel');
      const toggle = wrap.querySelector('.js-dp-toggle');
      const isOpen = wrap.classList.contains('is-open');

      if (openBtn && !isOpen) {
        toggle.classList.add('fade-out');
        scope.timeout(() => { toggle.style.visibility = 'hidden'; }, 180);

        wrap.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        panel?.setAttribute('aria-hidden', 'false');
      } else {
        closeDP(wrap);
      }
    }

    /* Instagram deep link fallback (unchanged) */
    if (igLink) {
      const deeplink = igLink.getAttribute('data-deeplink');
      const webUrl   = igLink.getAttribute('href');
      if (deeplink) {
        const start = Date.now();
        window.location.href = deeplink;
        scope.timeout(function() {
          if (Date.now() - start < 1600) {
            window.open(webUrl, '_blank', 'noopener');
          }
        }, 1200);
        e.preventDefault();
      }
    }
  }, true);

  /* Auto-close on movement ONLY (scroll/wheel/swipe). Regular taps are fine. */
  const closeAll = () => document.querySelectorAll('.dp.is-open').forEach(closeDP);
  scope.on('payment-panel.1', window, 'scroll', closeAll, { passive: true });
  scope.on('payment-panel.2', window, 'wheel', closeAll, { passive: true });
  scope.on('payment-panel.3', window, 'touchmove', closeAll, { passive: true });
})();

    },
    "payment-motion": function (root, config, scope) {

(function () {
  /* If an older patch was added, detach its listeners to avoid double-closing */
  if (window.__dpMotionGuard && typeof window.__dpMotionGuard.detach === 'function') {
    window.__dpMotionGuard.detach();
  }

  const GUARD_AFTER_LEAVE_MS = 350;  // buffer after hover leaves (trackpads/content shifts)
  const GUARD_AFTER_TAP_MS   = 500;  // buffer after tap/click so it doesn’t instantly close
  const SWIPE_THRESHOLD_PX   = 6;    // treat touch move > 6px as a swipe (should close)

  let guard = false;          // when true, movement won’t auto-close
  let guardTimer = null;
  let lastPointer = { x: 0, y: 0 };
  let touchFromLogo = false;
  let touchStartXY = null;

  function setGuard(on, ms) {
    if (on) {
      guard = true;
      if (ms) {
        scope.clear(guardTimer);
        guardTimer = scope.timeout(() => { guard = false; }, ms);
      }
    } else {
      scope.clear(guardTimer);
      guard = false;
    }
  }

  function isLogoEl(el) {
    return !!(el && el.closest && (el.closest('.dp-social-row') || el.closest('.dp-social-link')));
  }

  function closeDP(wrap) {
    if (!wrap || !wrap.classList.contains('is-open')) return;
    const panel  = wrap.querySelector('.dp-panel');
    const toggle = wrap.querySelector('.js-dp-toggle');
    wrap.classList.remove('is-open');
    if (panel)  panel.setAttribute('aria-hidden','true');
    if (toggle) {
      toggle.setAttribute('aria-expanded','false');
      toggle.style.visibility = '';
      toggle.classList.remove('fade-out');
    }
  }

  function closeAll() {
    if (guard) return;
    // On desktop, also skip closing if cursor is currently over the logo row
    const elUnderPointer = document.elementFromPoint(lastPointer.x, lastPointer.y);
    if (isLogoEl(elUnderPointer)) return;

    document.querySelectorAll('.dp.is-open').forEach(closeDP);
  }

  /* --- record pointer position for desktop/trackpad --- */
  scope.on('payment-motion.0', document, 'pointermove', (e) => {
    if (e.pointerType === 'touch') return;
    lastPointer.x = e.clientX;
    lastPointer.y = e.clientY;
  }, true);
  scope.on('payment-motion.1', document, 'mousemove', (e) => {
    lastPointer.x = e.clientX;
    lastPointer.y = e.clientY;
  }, true);

  /* --- desktop hover/click guard on logo row --- */
  scope.on('payment-motion.2', document, 'pointerenter', (e) => {
    if (e.pointerType === 'touch') return;
    if (isLogoEl(e.target)) setGuard(true);
  }, true);
  scope.on('payment-motion.3', document, 'pointerleave', (e) => {
    if (e.pointerType === 'touch') return;
    if (isLogoEl(e.target)) setGuard(true, GUARD_AFTER_LEAVE_MS);
  }, true);
  scope.on('payment-motion.4', document, 'pointerdown', (e) => {
    if (e.pointerType === 'touch') return;
    if (isLogoEl(e.target)) setGuard(true);
  }, true);
  scope.on('payment-motion.5', document, 'pointerup', (e) => {
    if (e.pointerType === 'touch') return;
    if (isLogoEl(e.target)) setGuard(true, GUARD_AFTER_TAP_MS);
  }, true);

  /* --- touch: allow tap on logos (no close), but swipes should still close --- */
  scope.on('payment-motion.6', document, 'touchstart', (e) => {
    const t = e.target;
    if (isLogoEl(t)) {
      touchFromLogo = true;
      const p = e.touches && e.touches[0];
      touchStartXY = p ? { x: p.clientX, y: p.clientY } : null;
      setGuard(true); // protect while finger is down on the logo
    } else {
      touchFromLogo = false;
      touchStartXY = null;
      setGuard(false);
    }
  }, { passive: true, capture: true });

  scope.on('payment-motion.7', document, 'touchmove', (e) => {
    // If movement started on a logo and user actually swipes, drop the guard -> close
    if (touchFromLogo && touchStartXY && e.touches && e.touches[0]) {
      const dx = Math.abs(e.touches[0].clientX - touchStartXY.x);
      const dy = Math.abs(e.touches[0].clientY - touchStartXY.y);
      if (dx > SWIPE_THRESHOLD_PX || dy > SWIPE_THRESHOLD_PX) {
        touchFromLogo = false;
        setGuard(false);
      }
    }
    closeAll(); // swipes should close unless guard is active (click/hold case)
  }, { passive: true });

  scope.on('payment-motion.8', document, 'touchend', (e) => {
    if (touchFromLogo) {
      // short grace so the tap doesn’t immediately trigger a close
      setGuard(true, GUARD_AFTER_TAP_MS);
    } else {
      setGuard(false);
    }
    touchFromLogo = false;
    touchStartXY = null;
  }, { passive: true, capture: true });

  scope.on('payment-motion.9', document, 'touchcancel', () => {
    touchFromLogo = false;
    touchStartXY = null;
    setGuard(false);
  }, { passive: true, capture: true });

  /* --- auto-close on movement (unchanged rule) --- */
  scope.on('payment-motion.10', window, 'wheel',  closeAll, { passive: true });
  scope.on('payment-motion.11', window, 'scroll', closeAll, { passive: true });

  // expose a small handle so we can remove listeners if needed later
  window.__dpMotionGuard = {
    detach() {
      scope.off(window, 'wheel',  closeAll);
      scope.off(window, 'scroll', closeAll);
    }
  };
})();

    },
    "payment-icons": function (root, config, scope) {

root.querySelectorAll(".custom_payment_icons").forEach(container => {
  const autoAnimationEnabled = container.dataset.autoAnimation === "true";

  scope.on('payment-icons.0', container, "mouseenter", () => {
    container.classList.add("show-text");
  });

  scope.on('payment-icons.1', container, "mouseleave", () => {
    container.classList.remove("show-text");
  });

  if (autoAnimationEnabled) {
    scope.interval(() => {
      container.classList.toggle("show-text");
    }, 5000);
  }
});


    },
    "payment-icons-ready": function (root, config, scope) {

scope.on('payment-icons-ready.0', document, "DOMContentLoaded", function () {
  const container = root.querySelector(".custom_payment_icons");
  if (!container) return;

  const autoAnimationEnabled = container.dataset.autoAnimation === "true";

  // Hover Animation (ALWAYS ON)
  scope.on('payment-icons-ready.1', container, "mouseenter", () => {
    container.classList.add("show-text");
  });

  scope.on('payment-icons-ready.2', container, "mouseleave", () => {
    container.classList.remove("show-text");
  });

  // Auto Animation (ONLY IF CHECKBOX ENABLED)
  if (autoAnimationEnabled) {
    scope.interval(() => {
      container.classList.toggle("show-text");
    }, 5000);
  }
});

    },
    "legacy-panel": function (root, config, scope) {

(function () {

  let autoCloseTimer = null;

  scope.on('legacy-panel.0', document, 'click', function (e) {

    const openBtn  = e.target.closest('.accordion-btn, .js-dp-toggle');
    const closeBtn = e.target.closest('.accordion-close-btn, .js-dp-close');

    /* ---------------- DP VERSION (has .dp wrapper) ---------------- */
    const dpBtn = e.target.closest('.js-dp-toggle, .js-dp-close') || (openBtn && openBtn.closest('.dp')) || (closeBtn && closeBtn.closest('.dp'));
    if (dpBtn) {
      return; // DP handled by its own script
    }

    /* ---------------- LEGACY VERSION (no .dp wrapper) ---------------- */
    if (openBtn) {
      e.preventDefault();

      const wrapper = openBtn.closest('.down_payment_link_main') || openBtn.parentElement;
      const content = wrapper && wrapper.querySelector('.accordion-content');
      if (!content) return;

      const isAlreadyOpen = content.classList.contains('active');

      // close others
      document.querySelectorAll('.accordion-content.active').forEach(el => el.classList.remove('active'));

      scope.clear(autoCloseTimer);

      if (!isAlreadyOpen) {
        scope.frame(() => {
          content.classList.add('active');
          autoCloseTimer = scope.timeout(() => {
            content.classList.remove('active');
          }, 45000);
        });
      }
    }

    if (closeBtn) {
      e.preventDefault();
      const wrapper = closeBtn.closest('.down_payment_link_main') || closeBtn.parentElement;
      const content = wrapper && wrapper.querySelector('.accordion-content');
      if (content) content.classList.remove('active');
      scope.clear(autoCloseTimer);
    }

  }, true);

})();

    },
    "variants": function (root, config, scope) {

  window.Shopify = window.Shopify || {};
  window.Shopify.variants = config.variants;
  root.__vaultVariants = config.variants;
  scope.cleanup(function () { delete root.__vaultVariants; });

    },
    "sticky-atc": function (root, config, scope) {

scope.on('sticky-atc.0', document, 'DOMContentLoaded', function () {
  const stickyAtc = byId(root, 'StickyAtcMobile');
  const mainAtc = root.querySelector(
    '.product__info-container .product-form__submit'
  );

  if (!stickyAtc || !mainAtc) return;

  // ---- Editable Breakpoints ----
  const rangeStart = 1;   // start showing at 8%
  const rangeEnd = 7;    // end showing at 12%
  const secondTrigger = 20; // also show at 20% and above
  // ------------------------------

  function onScroll() {
    if (window.innerWidth > 990) return;

    const scrollTop = window.scrollY;
    const docHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    if (docHeight <= 0) return;

    const scrollPercent = (scrollTop / docHeight) * 100;

    // Conditions:
    const inRange =
      scrollPercent >= rangeStart && scrollPercent <= rangeEnd;

    const highTrigger = scrollPercent >= secondTrigger;

    if (inRange || highTrigger) {
      stickyAtc.classList.add('is-visible');
    } else {
      stickyAtc.classList.remove('is-visible');
    }
  }

  scope.on('sticky-atc.1', window, 'scroll', onScroll, { passive: true });
});

    },
    "atc-schedule": function (root, config, scope) {

(function () {
  // The same metafield enables both schedulers. A normal product must remain completely untouched.
  const scheduleFlag = config.scheduleFlag;
  const scheduleEnabled = (scheduleFlag === true || scheduleFlag === 'true');
  const waitlist = root.querySelector('[data-vault-product-waitlist]');
  const waitlistForm = waitlist && waitlist.closest('form');
  const waitlistInput = waitlist && waitlist.querySelector('.vault-product-waitlist__input');
  const waitlistContainer = waitlist && waitlist.querySelector('.vault-product-waitlist__container');
  const waitlistSubmit = waitlist && waitlist.querySelector('.vault-product-waitlist__submit');
  const waitlistError = waitlist && waitlist.querySelector('.vault-product-waitlist__error');
  const waitlistSuccessBottom = waitlist && waitlist.querySelector('.vault-product-waitlist__success-bottom');
  const WAITLIST_RETURN = 'vault-product-waitlist-return';
  const waitlistTags = waitlist && waitlist.querySelector('.vault-product-waitlist__tags');
  const WAITLIST_KEY = 'vault-product-waitlist-until';
  const WAITLIST_MS = 24 * 60 * 60 * 1000;
  let scheduleClosed = false;

  // R50 (Mark 2026-10-26, for deployment): the test-only reload reset of the waitlist signup is gone – a signup is remembered for 24 h

  function waitlistUntil() {
    try { return parseInt(localStorage.getItem(WAITLIST_KEY), 10) || 0; } catch (e) { return 0; }
  }

  function signedUp() { return waitlistUntil() > Date.now(); }

  function saveSignup() {
    try { localStorage.setItem(WAITLIST_KEY, String(Date.now() + WAITLIST_MS)); } catch (e) {}
  }

  function isOwnWaitlistResponse() {
    if (!waitlistForm || !waitlistForm.id) return false;
    try {
      const hash = decodeURIComponent(new URL(window.location.href).hash.slice(1));
      // the early restore (main-product) already removed the #marker to stop the jump; it remembers which form posted
      let early = '';
      try { early = decodeURIComponent(window.__vaultWaitlistOwnPost || ''); } catch (e) { early = ''; }
      return hash === waitlistForm.id || early === waitlistForm.id;
    } catch (e) { return false; }
  }

  function waitlistState() {
    if (!waitlist) return 'before';
    if (waitlist.dataset.vaultWaitlistState === 'submitted') return 'submitted';
    if (waitlistForm && waitlistForm.classList.contains('is-open')) return 'open';
    return signedUp() ? 'signed' : 'before';
  }

  function rememberText(el) {
    if (el.__vaultAtcText == null) el.__vaultAtcText = el.textContent;
  }

  /* The first text this scheduler writes (page load, or a COMING SOON look switched in) and any text on a hidden
     button lands at once: animating it showed the old "CLICK AND MESSAGE US…" for a split second (Mark Round 17). */
  let firstLabelRender = true;
  function swapScheduledLabel(el, text) {
    const current = el.vaultSwapTimer ? el.vaultSwapText : el.textContent.trim();
    if (current === text) return;
    const btn = el.closest && el.closest('.js-message-button');
    if ((typeof firstLabelRender !== 'undefined' && firstLabelRender) || !window.vaultSwapLabel || (btn && (btn.style.display === 'none' || !btn.offsetParent))) {
      if (el.vaultSwapTimer) { clearTimeout(el.vaultSwapTimer); el.vaultSwapTimer = null; }
      if (el.vaultSwap) { el.vaultSwap.cancel(); el.vaultSwap = null; }
      el.vaultSwapText = text;
      if (el.textContent !== text) el.textContent = text;
      return;
    }
    window.vaultSwapLabel(el, text);
  }

  // One renderer owns the scheduled button text. Observer/minute/variant refreshes and fetched-Look
  // scheduler replacements all read the existing panel state instead of resetting it.
  function renderScheduledButton(closed) {
    const state = waitlistState();
    root.querySelectorAll('.normal_text_sold_out').forEach(function(el) {
      rememberText(el);
      /* write only a change: the scheduler's subtree observer calls apply() on every text write, so an
         unconditional write looped forever and froze COMING SOON pages (Round 12) */
      const sold = closed ? 'COMING SOON' : el.__vaultAtcText;
      if (el.textContent !== sold) el.textContent = sold;
    });
    root.querySelectorAll('.normal_text_info').forEach(function(el) {
      rememberText(el);
      if (!closed) { swapScheduledLabel(el, el.__vaultAtcText); return; }
      const text = state === 'open' ? 'ENTER YOUR EMAIL BELOW'
        : state === 'submitted' ? "YOU'RE ON THE LIST"
        : state === 'signed' ? 'CLICK AND MESSAGE US TO JOIN THE LIST'
        : 'CLICK TO JOIN THE LIST';
      swapScheduledLabel(el, text);
    });
  }

  function setPanelOpen(open, preserveState) {
    if (!waitlist || !waitlistForm) return;
    waitlistForm.classList.toggle('is-open', open);
    waitlist.classList.toggle('is-open', open);
    waitlist.setAttribute('aria-hidden', open ? 'false' : 'true');
    root.querySelectorAll('.js-message-button').forEach(function(btn) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (!preserveState) waitlist.dataset.vaultWaitlistState = open ? 'open' : (signedUp() ? 'signed' : 'before');
    if (open && typeof loadSchedule === 'function') loadSchedule(); // have the coming-soon message ready before ENTER (R21)
    renderScheduledButton(scheduleClosed);
  }

  function resetWaitlist() {
    if (!waitlist || !waitlistForm) return;
    waitlistForm.classList.remove('is-open');
    waitlist.classList.remove('is-open');
    waitlist.setAttribute('aria-hidden', 'true');
    waitlist.dataset.vaultWaitlistState = signedUp() ? 'signed' : 'before';
    root.querySelectorAll('.js-message-button').forEach(function(btn) { btn.setAttribute('aria-expanded', 'false'); });
  }

  if (!scheduleEnabled) {
    csRecord(false);
    // First install on a normal product remains a strict no-op. Only a prior scheduled source leaves this marker.
    if (root.__vaultScheduledWaitlist) {
      root.__vaultScheduledWaitlist = false;
      root.__vaultAtcScheduleClosed = false;
      if (root.classList) root.classList.remove('vault-sched-closed');
      resetWaitlist();
    }
    return;
  }
  root.__vaultScheduledWaitlist = true;

  if (waitlist) {
    const handle = String(config.productHandle || waitlist.dataset.productHandle || '').trim();
    const title = String(config.productTitle || waitlist.dataset.productTitle || '').trim();
    if (handle) waitlist.dataset.productHandle = handle;
    if (title) waitlist.dataset.productTitle = title;
    if (waitlistTags) waitlistTags.value = 'prospect, product page, email subscription, vault product ' + handle;
  }

  /* Mark R27: a COMING SOON (closed) style or colour page shows its style row straight away – style/colour tiles only,
     no size or quality – so shoppers can still see and pick the other styles. The options stay formally closed
     (gallery, saved picks and buttons behave as before). Picking a style that is open runs the real VIEW OPTIONS. */
  /* One rule for every style switch on a page with COMING SOON looks (Mark R28): the button on screen holds until the
     picked look has arrived, then a COMING SOON look shows the style row only (size/quality slide out), an open look
     slides them back in, and the button cross-fades straight to its final words. */
  // Every schedule copy (the page's own and each look's) answers "closed or not" for ITS product on the shared section;
  // the style-row rule reads the answer for the product the picker shows now, so a stale copy can't decide (R28).
  function csSection() { return (root.closest && root.closest('.shopify-section')) || root; }
  function csCurrentHandle(picker) {
    const v = picker && typeof picker.styleVariant === 'function' ? picker.styleVariant() : (picker && typeof picker.variant === 'function' ? picker.variant() : null);
    const m = v && v.look && v.url ? String(v.url).match(/\/products\/([^/?#]+)/) : null;
    return m ? decodeURIComponent(m[1]) : (picker && picker.data ? picker.data.handle : null);
  }
  function csRecord(closed) {
    const sec = csSection();
    const handle = String(config.productHandle || '').trim();
    if (handle) (sec.__vaultCsState || (sec.__vaultCsState = {}))[handle] = closed;
    sec.__vaultCsSync = function() { syncCsRail(null); };
    const picker = sec.querySelector('vault-picker');
    if (handle && handle === csCurrentHandle(picker)) {
      sec.__vaultAtcScheduleClosed = closed;
      if (sec.classList) sec.classList.toggle('vault-sched-closed', !!closed);
      if (closed && picker && typeof picker.endRecovery === 'function') {
        if (picker.recover) sec.querySelectorAll('.vault-btn-ghost').forEach(function(g) { g.remove(); });
        picker.endRecovery(false, true); // no outgoing recovery-label ghost over COMING SOON
        if (sec.classList) sec.classList.remove('vault-recover');
      }
    }
    if (picker && !picker.__vaultCsClick) {
      picker.__vaultCsClick = true;
      picker.addEventListener('click', function() { setTimeout(function() { if (sec.__vaultCsSync) sec.__vaultCsSync(); }, 0); });
    }
    syncCsRail(closed);
  }

  function syncCsRail(closedLook) {
    const sec = csSection();
    const picker = sec.querySelector('vault-picker');
    if (!picker || !picker.rows) return;
    const styleK = picker.rows.findIndex(function(r) { return r.kind === 'style'; });
    if (styleK < 0 || picker.querySelectorAll('.vault-picker__row[data-kind="style"] .vault-picker__tile').length < 2) return;
    const info = sec.__vaultCsInfo || (sec.__vaultCsInfo = sec.querySelector('.vault-bn-closed') || picker.parentElement);
    const styleNow = picker.pick ? picker.pick[styleK] : null;
    if (info.__vaultCsTransition && info.__vaultCsTransition.style !== styleNow) cancelRailTransition(info);
    const state = sec.__vaultCsState || {};
    const cur = csCurrentHandle(picker);
    const curClosed = cur != null && state[cur] === true;
    if (curClosed) sec.__vaultCsSeen = true;
    if (info.__vaultCsDecided === undefined) {
      // first answer for this page: a COMING SOON arrival opens on the style row only (under the preloader, no motion).
      // Not after a tap: arriving on an open style, the page's own answer can come before the picker is ready, so the first
      // COMING SOON tap landed here – rows hidden at once with their height still held, a 173 px gap pushed the button and
      // AKI/SKY down for a second (Mark R35). A tap goes through the normal fold below.
      if (!picker.querySelector('.vault-picker__tiles.is-touched')) {
        info.__vaultCsDecided = styleNow;
        if (curClosed) info.classList.add('vault-cs-rail');
        return;
      }
      info.__vaultCsDecided = null;
    }
    // arrival only (before the shopper's first style tap): the schedule may answer a moment after the first call
    if (curClosed && !info.__vaultCsTouched && styleNow === info.__vaultCsDecided && !info.classList.contains('vault-cs-rail')) {
      info.classList.add('vault-cs-rail');
      return;
    }
    if (!sec.__vaultCsSeen || styleNow == null || styleNow === info.__vaultCsDecided) return;
    /* R33: the page's own product (answered at load) or a look whose schedule started with the tap (picker preSchedule)
       is decided in the tap's own frame – button and rows change together, nothing to hold or wait for. A watch the
       old copy's clean-up started a moment earlier in the same tap is taken over. */
    const quick = cur != null && (cur in state) && ((picker.data && cur === picker.data.handle) || sec.__vaultCsFresh === cur);
    if (info.__vaultCsWatch === styleNow && !quick) return;
    info.__vaultCsTouched = true;
    if (info.__vaultCsWatch !== styleNow || !info.__vaultCsUnpin) {
      /* R42 P1-1-07: a look swiped in on the big photo keeps the PHOTO still (the picker's photo anchor); pinning the
         style row too scrolled the photo away 173 px and the two fought every frame */
      const photoHeld = !!(picker.tileAnchor && picker.tileAnchor.tile && picker.tileAnchor.tile.swiper);
      const pinRow = photoHeld ? null : picker.querySelector('.vault-picker__row[data-kind="style"]');
      if (info.__vaultCsUnpin) info.__vaultCsUnpin(0);
      info.__vaultCsUnpin = pinStyleRow(pinRow, pinRow ? pinRow.getBoundingClientRect().top : 0, 12000);
    }
    clearInterval(info.__vaultCsTimer);
    if (quick) {
      info.__vaultCsWatch = null; info.__vaultCsDecided = styleNow;
      csUnpinSettled(info, picker);
      csDecide(info, picker, sec, state[cur] === true);
      return;
    }
    info.__vaultCsWatch = styleNow;
    holdButtons(true);
    let tries = 0;
    info.__vaultCsTimer = setInterval(function() {
      const now = picker.pick ? picker.pick[styleK] : null;
      if (now !== info.__vaultCsWatch) { clearInterval(info.__vaultCsTimer); info.__vaultCsWatch = null; holdButtons(false); return; }
      // decide once the picked look has arrived AND its own schedule copy has answered; 4 s cap for slow phones
      tries++;
      const v = typeof picker.variant === 'function' ? picker.variant() : null;
      const handle = csCurrentHandle(picker);
      const st = sec.__vaultCsState || {};
      const known = handle != null && (handle in st);
      const own = picker.data && handle === picker.data.handle; // the page's own product: answered at load, no refetch
      const arrived = known && (own || sec.__vaultCsFresh === handle || (!picker.pricePending && (!v || !picker.priceVariant || String(picker.priceVariant) === String(v.id))));
      if (!arrived || tries < 2) {
        if (tries < 60) return; // up to 9 s on a slow connection
        // still no answer for this look: never guess – leave the rows as they are and let the real button show
        clearInterval(info.__vaultCsTimer); info.__vaultCsWatch = null; info.__vaultCsDecided = now;
        holdButtons(false, 0); if (info.__vaultCsUnpin) info.__vaultCsUnpin(600); return;
      }
      clearInterval(info.__vaultCsTimer); info.__vaultCsWatch = null; info.__vaultCsDecided = now;
      csUnpinSettled(info, picker);
      csDecide(info, picker, sec, handle != null && st[handle] === true);
    }, 150);
  }

  // phones: the style row stays pinned until the picked style's page has landed too – its price block (hidden on a COMING
  // SOON style) can grow above the row seconds later on a slow connection (+21 px after the pin had let go, R33)
  function csUnpinSettled(info, picker) {
    const ctl = info.__vaultCsUnpin;
    if (!ctl) return;
    let n = 0;
    (function wait() {
      if (info.__vaultCsUnpin !== ctl) return; // a newer switch owns the pin
      if (picker.pricePending && n++ < 70 && typeof setTimeout === 'function') { setTimeout(wait, 150); return; }
      ctl(600);
    })();
  }

  function cancelRailTransition(info) {
    const previous = info.__vaultCsTransition;
    info.__vaultCsTransition = null;
    if (previous) previous.animations.forEach(function(a) { a.cancel(); });
  }

  function csDecide(info, picker, sec, closed) {
    cancelRailTransition(info);
    const styleK = picker.rows.findIndex(function(r) { return r.kind === 'style'; });
    info.__vaultCsTransition = { closed: closed, style: picker.pick[styleK], animations: [] };
    const rail = info.classList.contains('vault-cs-rail');
    if (!closed) csOpenButtons(sec, picker, rail);
    if (closed && !rail) retractToRail(info, picker);
    else if (!closed && rail) openFromRail(info, picker);
    else holdButtons(false, 120, closed ? 'msg' : 'add');
  }

  // the button about to show says its final words at once (VIEW OPTIONS → CHOOSE YOUR SIZE played on screen, R33)
  function csSetLabels(sec, picker) {
    if (!picker || typeof picker.ctaText !== 'function') return;
    const text = picker.ctaText();
    sec.querySelectorAll('[id^="ProductSubmitButton-"] > span, #StickyAtcMobile button[name="add"] > span').forEach(function(span) {
      if (span.closest('.vault-atc-run')) return; // the Add to Cart transition owns its label
      if (span.dataset) delete span.dataset.vaultLabel;
      clearTimeout(span.vaultSwapTimer); span.vaultSwapTimer = null;
      if (span.vaultSwap) { span.vaultSwap.cancel(); span.vaultSwap = null; }
      span.vaultSwapText = text;
      if (span.textContent !== text) span.textContent = text;
    });
  }

  /* an open look picked: undo the closed button state left by the previous look's schedule copy (those copies may no
     longer paint, so nothing else would) – the real ADD TO CART / CHOOSE YOUR SIZE comes back under the frozen copy */
  function csOpenButtons(sec, picker, opening) {
    if (opening) csSetLabels(sec, picker);
    [sec].concat(Array.prototype.slice.call(sec.querySelectorAll('.vault-sched-closed'))).forEach(function(el) { el.classList.remove('vault-sched-closed'); el.__vaultAtcScheduleClosed = false; });
    sec.querySelectorAll('.js-message-button').forEach(function(b) { if (!b.hasAttribute('data-vault-cs-ghost')) b.style.display = 'none'; });
    sec.querySelectorAll('[id^="ProductSubmitButton-"], #StickyAtcMobile button[name="add"]').forEach(function(b) {
      b.style.display = ''; b.removeAttribute('disabled'); if (b.dataset) { delete b.dataset.vaultSchedOff; delete b.dataset.vaultClosedOff; }
    });
    if (typeof picker.syncCta === 'function') picker.syncCta();
  }

  // keep the style row where it is on phones while rows appear/disappear above it (a touch or wheel hands the page back)
  function pinStyleRow(styleRow, y0, ms) {
    if (!styleRow || (window.matchMedia && window.matchMedia('(min-width: 990px)').matches)) { const off = function() {}; off.now = function() {}; return off; }
    let stop = false, until = performance.now() + (ms || 1100);
    const release = function() { stop = true; };
    window.addEventListener('touchstart', release, { once: true, passive: true });
    window.addEventListener('wheel', release, { once: true, passive: true });
    (function keep() {
      if (stop) return;
      const dy = styleRow.getBoundingClientRect().top - y0;
      if (Math.abs(dy) > 0.5) window.scrollBy(0, dy);
      if (performance.now() < until) requestAnimationFrame(keep);
      else { window.removeEventListener('touchstart', release); window.removeEventListener('wheel', release); }
    })();
    // the caller can end it a little after its change has landed, and correct right away after a layout change
    const ctl = function(after) { until = Math.min(until, performance.now() + (after || 0)); };
    ctl.now = function() { if (stop) return; const dy = styleRow.getBoundingClientRect().top - y0; if (Math.abs(dy) > 0.5) window.scrollBy(0, dy); };
    return ctl;
  }

  // back to a COMING SOON look: size/quality slide out (the push-in motion in reverse), then the style row only
  function retractToRail(info, picker) {
    const transition = info.__vaultCsTransition;
    const styleRow = picker.querySelector('.vault-picker__row[data-kind="style"]');
    const rows = Array.prototype.filter.call(picker.querySelectorAll('.vault-picker__row:not([data-kind="style"]), .vault-picker__chart'), function(el) { return el.offsetHeight; });
    const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const finish = function() {
      if (info.__vaultCsTransition !== transition || !transition.closed) return;
      if (!(csSection().__vaultCsState || {})[csCurrentHandle(picker)]) return;
      const y0 = styleRow ? styleRow.getBoundingClientRect().top : 0;
      if (typeof picker.releaseInfoHold === 'function') picker.releaseInfoHold();
      info.classList.add('vault-cs-rail');
      if (info.__vaultCsUnpin) info.__vaultCsUnpin.now(); // same frame: the style row never jumps
      holdButtons(false, 120, 'msg');
    };
    if (calm || !rows.length || !rows[0].animate) { finish(); return; }
    let left = rows.length;
    rows.forEach(function(el) {
      const animation = el.animate([{ opacity: 1, filter: 'blur(0)', transform: 'none' }, { opacity: 0, filter: 'blur(6px)', transform: 'translateY(8px)' }],
        { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });
      transition.animations.push(animation);
      animation.onfinish = function() {
        if (info.__vaultCsTransition !== transition) return;
        if (--left === 0) { finish(); requestAnimationFrame(function() {
          if (info.__vaultCsTransition !== transition) return;
          transition.animations.forEach(function(a) { a.cancel(); });
          transition.animations = [];
        }); }
      };
    });
  }

  // a frozen copy of the button on screen sits over the real ones while they change underneath, then fades away
  function holdButtons(on, wait, want) {
    if (!window.__vaultCsGhosts) return; // R32e: off by default – with only the current look's schedule painting, the real button already switches cleanly
    // only the main bar (the first one with a copy) decides when the copies lift; every other bar (the sticky one) lifts
    // with it – a hidden COMING SOON in the sticky bar kept its CHOOSE YOUR SIZE copy up 2.5 s (R32)
    const boxes = Array.prototype.slice.call(csSection().querySelectorAll('.product-form__buttons'));
    const lead = !on ? boxes.find(function(b) { return b.__vaultCsGhost && b.offsetParent; }) || boxes.find(function(b) { return b.__vaultCsGhost; }) : null;
    let leadDone = !lead;
    boxes.forEach(function(box) {
      if (on) {
        if (box.__vaultCsGhost) return;
        const vis = Array.prototype.find.call(box.children, function(c) { return c.offsetParent && /product-form__submit|js-message-button/.test(c.className || '') && !c.classList.contains('vault-btn-ghost'); });
        if (!vis) return;
        /* a plain picture of the button: every look written inline, no classes or ids, so the schedule scripts (which
           find buttons and texts by class) can never hide or rewrite it */
        const g = vis.cloneNode(true);
        const props = ['display', 'flex-direction', 'align-items', 'justify-content', 'gap', 'box-sizing', 'width', 'height', 'min-height',
          'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'margin-top', 'margin-bottom', 'background-color', 'background-image',
          'color', 'border-top', 'border-right', 'border-bottom', 'border-left', 'border-radius', 'box-shadow', 'font-family', 'font-size',
          'font-weight', 'font-style', 'letter-spacing', 'line-height', 'text-transform', 'text-align', 'white-space'];
        // never the button's mid-fade opacity/blur/offset: a copy taken during a cross-fade came out see-through (blank)
        const copy = function(from, to) {
          const cs = getComputedStyle(from);
          to.removeAttribute('class'); to.removeAttribute('id'); to.removeAttribute('style');
          props.forEach(function(k) { to.style.setProperty(k, cs.getPropertyValue(k)); });
          to.style.setProperty('animation', 'none'); to.style.setProperty('transition', 'none');
          to.style.setProperty('text-decoration', 'none'); // the copy is a bare link: no underline (Mark R28 pic)
          const fk = from.children, tk = to.children;
          for (let i = 0; i < fk.length && i < tk.length; i++) copy(fk[i], tk[i]);
        };
        copy(vis, g);
        // a button caught mid label-swap copies as blank: give the copy its words (Mark R32 – blank button on phones)
        if (!g.textContent.replace(/\s+/g, '').length) {
          const pk = csSection().querySelector('vault-picker');
          const words = vis.classList.contains('js-message-button') ? 'COMING SOON' : (pk && typeof pk.ctaText === 'function' ? pk.ctaText() : '');
          const holder = g.querySelector('span, p') || g;
          if (words) holder.textContent = words;
        }
        g.setAttribute('aria-hidden', 'true'); g.setAttribute('data-vault-cs-ghost', '');
        if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
        g.style.cssText += ';position:absolute;margin:0;pointer-events:none;z-index:3;display:' + getComputedStyle(vis).display +
          ';top:' + vis.offsetTop + 'px;left:' + vis.offsetLeft + 'px;width:' + vis.offsetWidth + 'px;height:' + vis.offsetHeight + 'px;';
        box.appendChild(g);
        // its words must really show (a label caught mid-swap can be present but hidden): else a plain label (R32)
        if (!(g.innerText || '').replace(/\s+/g, '').length) {
          const pk2 = csSection().querySelector('vault-picker');
          const say = vis.classList.contains('js-message-button') ? 'COMING SOON' : (pk2 && typeof pk2.ctaText === 'function' ? pk2.ctaText() : '');
          if (say) { g.textContent = ''; const sp = document.createElement('span'); sp.textContent = say; g.appendChild(sp); }
        }
        box.__vaultCsGhost = g;
        box.classList.add('vault-cs-holding');
        return;
      }
      const g = box.__vaultCsGhost;
      if (!g) return;
      box.__vaultCsGhost = null;
      // wait until the real button underneath shows its final words (its label swap has finished), max ~1.2 s
      const settled = function() {
        // the button the decided state needs: COMING SOON (message button) or the normal one (not the outgoing button)
        const real = Array.prototype.find.call(box.children, function(c) {
          if (c === g || getComputedStyle(c).display === 'none' || c.classList.contains('vault-btn-ghost')) return false;
          const msg = c.classList.contains('js-message-button');
          if (want === 'msg') return msg;
          if (want === 'add') return !msg && c.classList.contains('product-form__submit');
          return msg || c.classList.contains('product-form__submit');
        });
        if (!real) {
          // a box that has no button of the needed kind at all (e.g. the second/sticky bar) releases at once;
          // one whose button exists but isn't shown yet keeps the copy (R32: a CHOOSE YOUR SIZE copy sat on COMING SOON)
          const exists = Array.prototype.some.call(box.children, function(c) {
            if (c === g || c.classList.contains('vault-btn-ghost')) return false;
            const msg = c.classList.contains('js-message-button');
            return want === 'msg' ? msg : want === 'add' ? (!msg && c.classList.contains('product-form__submit')) : (msg || c.classList.contains('product-form__submit'));
          });
          return !exists;
        }
        // its words must really be showing (not faded or hidden). Measured with the hold lifted for this instant
        // (same task, nothing is painted in between) because the hold itself hides everything.
        box.classList.remove('vault-cs-holding');
        const shown = Array.prototype.some.call(real.querySelectorAll('span, p'), function(el) {
          if (!el.textContent.trim()) return false;
          const cs = getComputedStyle(el);
          if (cs.display === 'none' || cs.visibility === 'hidden') return false;
          for (let n = el; n && n !== box; n = n.parentElement) { if (parseFloat(getComputedStyle(n).opacity) < 0.9) return false; }
          return true;
        });
        box.classList.add('vault-cs-holding');
        const busy = real.getAnimations ? real.getAnimations({ subtree: true }).some(function(a) { return a.playState === 'running'; }) : false;
        return shown && !busy;
      };
      let waited = 0;
      const isLead = box === lead;
      setTimeout(function check() {
        if (!isLead) { if (!leadDone && waited < 2500) { waited += 60; setTimeout(check, 60); return; } }
        else if (!settled() && waited < 2500) { waited += 60; setTimeout(check, 60); return; }
        // the real button often plays its own text fade right after it appears: give it that moment under the copy
        if (isLead && !box.__vaultCsSettledAt) { box.__vaultCsSettledAt = performance.now(); setTimeout(check, 450); return; }
        box.__vaultCsSettledAt = 0;
        if (isLead) leadDone = true;
        box.classList.remove('vault-cs-holding');
        if (!g.animate) { g.remove(); return; }
        g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 350, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'forwards' }).onfinish = function() { g.remove(); };
        setTimeout(function() { g.remove(); }, 600);
      }, wait || 0);
    });
  }

  function openFromRail(info, picker) {
    const transition = info.__vaultCsTransition;
    const styleRow = picker.querySelector('.vault-picker__row[data-kind="style"]');
    const y0 = styleRow ? styleRow.getBoundingClientRect().top : 0;
    const rows = Array.prototype.slice.call(picker.querySelectorAll('.vault-picker__row:not([data-kind="style"]), .vault-picker__chart'));
    if (typeof picker.releaseInfoHold === 'function') picker.releaseInfoHold();
    info.classList.remove('vault-cs-rail');
    if (picker.vaultMemo) picker.vaultMemo.deferred = null; // the style just tapped wins over remembered picks
    csSetLabels(csSection(), picker);
    if (info.classList.contains('vault-bn-closed') && typeof info.vaultOpenOptions === 'function') info.vaultOpenOptions(null, true);
    if (info.__vaultCsUnpin) info.__vaultCsUnpin.now(); // same frame: the style row never jumps
    // the real button settles (its label swap finishes) under the frozen one, then the copy fades away
    holdButtons(false, 120, 'add');
    const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (calm) return;
    rows.forEach(function(el) {
      if (!el.offsetHeight || !el.animate) return;
      transition.animations.push(el.animate([{ opacity: 0, filter: 'blur(6px)', transform: 'translateY(8px)' }, { opacity: 1, filter: 'blur(0)', transform: 'none' }],
        { duration: 450, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }));
    });
  }

  let restoreRegistered = false;
  function restoreATCState() {
    if (root.classList) root.classList.remove('vault-sched-closed');
    if (csSection().__vaultCsSync) csSection().__vaultCsSync();
    root.querySelectorAll('.normal_text_sold_out, .normal_text_info').forEach(function(el) {
      if (el.__vaultAtcText != null) { if (el.textContent !== el.__vaultAtcText) el.textContent = el.__vaultAtcText; delete el.__vaultAtcText; }
    });
    /* Availability comes from the picker's current choice first: the form's variant can still be the previous look's,
       which left NBA COLLAB's CHOOSE YOUR QUALITY greyed out (Mark Round 17). A sold-out choice stays disabled. */
    const pk = root.querySelector && root.querySelector('vault-picker');
    let chosen = null;
    try { chosen = pk && typeof pk.variant === 'function' ? pk.variant() : null; } catch (e) { chosen = null; }
    const selected = chosen || getSelectedVariant();
    root.querySelectorAll('form[data-type="add-to-cart-form"] button[name="add"], .js-add-to-cart').forEach(function(btn) {
      if (btn.dataset) delete btn.dataset.vaultSchedOff;
      if (!selected || selected.available === false) btn.setAttribute('disabled', 'disabled');
      else btn.removeAttribute('disabled');
    });
    root.querySelectorAll('.shopify-payment-button').forEach(function(btn) {
      if (btn.__vaultAtcDisplay != null) { btn.style.display = btn.__vaultAtcDisplay; delete btn.__vaultAtcDisplay; }
    });
  }

  function registerRestore() {
    if (!restoreRegistered) {
      restoreRegistered = true;
      scope.cleanup(function() {
        root.__vaultAtcScheduleClosed = false;
        restoreATCState();
      });
    }
  }

  // ATC uses its own settings below the Price settings.
  const cfg = {
    weeklyStartDay: config.atc_weekly_start_day,
    weeklyStartTime: config.atc_weekly_start_time,
    weeklyEndDay: config.atc_weekly_end_day,
    weeklyEndTime: config.atc_weekly_end_time,
    useCustom: config.atc_schedule_use_custom,
    customStartText: config.atc_custom_start,
    customEndText: config.atc_custom_end,
    graceDays: config.atc_grace_days
  };

  const DAY_MS = 86400000;
  const MIN_MS = 60000;
  const PHT_OFFSET_MS = 8 * 60 * 60 * 1000;
  const CUSTOM_PLACEHOLDER = "1970-01-01 00:00";

  function dayToNum(d) {
    const map = { sun:0, mon:1, tue:2, wed:3, thu:4, fri:5, sat:6 };
    return map[String(d || '').toLowerCase()] ?? 6;
  }

  function parseTimeHHMM(str, fallbackMinutes) {
    const s = String(str || '').trim();
    const m = s.match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return fallbackMinutes;
    const hh = parseInt(m[1], 10);
    const mm = parseInt(m[2], 10);
    if (isNaN(hh) || isNaN(mm) || hh < 0 || hh > 23 || mm < 0 || mm > 59) return fallbackMinutes;
    return (hh * 60) + mm;
  }

  function parseCustomDateTime(str) {
    const s = String(str || '').trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})$/);
    if (!m) return null;
    const Y  = parseInt(m[1], 10);
    const Mo = parseInt(m[2], 10) - 1;
    const D  = parseInt(m[3], 10);
    const H  = parseInt(m[4], 10);
    const Mi = parseInt(m[5], 10);
    if ([Y,Mo,D,H,Mi].some(n => isNaN(n))) return null;
    return Date.UTC(Y, Mo, D, H, Mi);
  }

  function computeInsideWindow(nowShifted) {
    const nowDate = new Date(nowShifted);

    const startDayNum = dayToNum(cfg.weeklyStartDay);
    const endDayNum   = dayToNum(cfg.weeklyEndDay);
    const startMin = parseTimeHHMM(cfg.weeklyStartTime, (20*60 + 15));
    const endMin   = parseTimeHHMM(cfg.weeklyEndTime, (23*60 + 59));

    const Y = nowDate.getUTCFullYear();
    const M = nowDate.getUTCMonth();
    const D = nowDate.getUTCDate();
    const dowNow = nowDate.getUTCDay();

    const todayMidnight = Date.UTC(Y, M, D);
    const startOfWeek = todayMidnight - (dowNow * DAY_MS);

    let weeklyStartThis = startOfWeek + (startDayNum * DAY_MS) + (startMin * MIN_MS);
    let weeklyEndThis   = startOfWeek + (endDayNum   * DAY_MS) + (endMin   * MIN_MS);
    if (weeklyEndThis <= weeklyStartThis) weeklyEndThis += (7 * DAY_MS);

    const weeklyStartLast = weeklyStartThis - (7 * DAY_MS);
    const weeklyEndLast   = weeklyEndThis   - (7 * DAY_MS);

    let insideWeekly =
      (nowShifted >= weeklyStartThis && nowShifted <= weeklyEndThis) ||
      (nowShifted >= weeklyStartLast && nowShifted <= weeklyEndLast);

    // Custom override
    const useCustom = !!cfg.useCustom;
    let customStartText = cfg.customStartText;
    let customEndText   = cfg.customEndText;
    if (customStartText === CUSTOM_PLACEHOLDER) customStartText = "";
    if (customEndText   === CUSTOM_PLACEHOLDER) customEndText   = "";

    const customStart = useCustom ? parseCustomDateTime(customStartText) : null;
    const customEnd   = useCustom ? parseCustomDateTime(customEndText)   : null;
    const customValid = !!(customStart && customEnd && customEnd > customStart);

    let insideWindow = insideWeekly;

    if (useCustom && customValid) {
      if (nowShifted <= customEnd) {
        insideWindow = (nowShifted >= customStart && nowShifted <= customEnd);
      } else if (config.atc_custom_only) {
        /* Drop schedule: after the drop closes the button stays off (no weekly fallback, no grace). */
        return false;
      } else {
        insideWindow = insideWeekly;
      }
    }

    // Grace days after window ends
    let graceDays = parseInt(cfg.graceDays, 10);
    if (isNaN(graceDays) || graceDays < 0) graceDays = 0;
    if (graceDays > 30) graceDays = 30;

    if (!insideWindow && graceDays > 0) {
      const lastWeeklyEnd = (nowShifted >= weeklyEndThis) ? weeklyEndThis : weeklyEndLast;
      let lastEndMs = lastWeeklyEnd;
      if (customValid && customEnd && nowShifted >= customEnd) lastEndMs = Math.max(lastEndMs, customEnd);
      if (lastEndMs && nowShifted <= (lastEndMs + (graceDays * DAY_MS))) insideWindow = true;
    }

    return insideWindow;
  }

  function windowIsOpenNow() {
    if (!scheduleEnabled) return true;
    const nowShifted = Date.now() + PHT_OFFSET_MS;
    return computeInsideWindow(nowShifted);
  }

  function getSelectedVariant() {
    const input = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    const id = input ? input.value : null;
    const list = variantList(root);
    if (!id) return list.length ? list[0] : null;
    return list.find(v => String(v.id) === String(id)) || null;
  }

  function syncAllATCVariantInputs(variant) {
    if (!variant || !variant.id) return;
    root.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(inp => {
      inp.value = variant.id;
      // IMPORTANT: we do NOT disable/enable the input here (Shopify handles that)
    });
  }

  function apply(variantFromEvent) {
    /* every look switch starts a new schedule copy on the same section and the old ones kept running, each painting the
       buttons for ITS product (TAPE TYPE's copy forced COMING SOON back onto UPSIDE DOWN; OUT OF STOCK flashes): only the
       copy for the product the picker shows now may paint (Mark R28) */
    const pk = csSection().querySelector('vault-picker');
    const curH = pk && pk.rows ? csCurrentHandle(pk) : null;
    const ownH = String(config.productHandle || '').trim();
    if (curH && ownH && curH !== ownH) return;
    const v = variantFromEvent || getSelectedVariant();
    if (v) syncAllATCVariantInputs(v);

    const forceSoldOut = scheduleEnabled && !windowIsOpenNow();
    /* CEO 2026-11-04: when the drop opens/closes while the page is open, the buy button changes with the same
       animation as a style swap (picker watchButtons), on desktop and mobile (CEO 2026-11-05, video 1). */
    let timeSwap = null;
    if (root.__vaultLastForce != null && root.__vaultLastForce !== forceSoldOut && pk && typeof pk.watchButtons === 'function') {
      try { timeSwap = pk.watchButtons(); } catch (e) { timeSwap = null; }
    }
    root.__vaultLastForce = forceSoldOut;
    const realSoldOut  = !v || v.available === false;
    const sold = forceSoldOut || realSoldOut;
    scheduleClosed = forceSoldOut;
    root.__vaultAtcScheduleClosed = forceSoldOut;
    csRecord(!!forceSoldOut);

    const addBtns = root.querySelectorAll(
      'form[data-type="add-to-cart-form"] button[name="add"], .js-add-to-cart'
    );
    const msgBtns = root.querySelectorAll('.js-message-button');
    const paymentBtns = root.querySelectorAll('.shopify-payment-button');
    const soldTexts = root.querySelectorAll('.normal_text_sold_out');
    const infoTexts = root.querySelectorAll('.normal_text_info');

    if (addBtns.length || msgBtns.length || paymentBtns.length || soldTexts.length || infoTexts.length) registerRestore();

    soldTexts.forEach(rememberText);
    infoTexts.forEach(rememberText);
    if (!forceSoldOut && waitlistForm && waitlistForm.classList.contains('is-open')) setPanelOpen(false);
    renderScheduledButton(forceSoldOut);

    paymentBtns.forEach(btn => {
      if (btn.__vaultAtcDisplay == null) btn.__vaultAtcDisplay = btn.style.display;
      btn.style.display = sold ? 'none' : '';
    });

    addBtns.forEach(btn => {
      btn.style.display = sold ? 'none' : '';
      if (sold) { btn.setAttribute('disabled','disabled'); if (btn.dataset) btn.dataset.vaultSchedOff = '1'; }
      else { btn.removeAttribute('disabled'); if (btn.dataset) delete btn.dataset.vaultSchedOff; }
    });

    msgBtns.forEach(btn => {
      btn.style.display = sold ? '' : 'none';
    });
    firstLabelRender = false;
    if (root.classList) root.classList.toggle('vault-sched-closed', !!forceSoldOut);
    if (timeSwap) { try { timeSwap(); } catch (e) {} }
  }

  // Hard block: even if something tries to submit while closed, stop it.
  scope.on('atc-schedule.0', document, 'submit', function(e) {
    const form = e.target;
    if (!form || !root.contains(form) || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    if (scheduleEnabled && !windowIsOpenNow()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      apply();
    }
  }, true);

  scope.on('atc-schedule.1', document, 'variant:change', function(e) {
    if (!e.detail || !e.detail.variant) return;
    if (!variantList(root).some(function (variant) { return String(variant.id) === String(e.detail.variant.id); })) return;
    apply(e.detail.variant);
  }, true);

  scope.on('atc-schedule.2', document, 'shopify:section:load', function() {
    apply();
  });

  // Check the ATC schedule exactly when a new minute starts.
  function scheduleATCMinuteCheck() {
    const delay = 60000 - (Date.now() % 60000) + 100;

    scope.timeout(function() {
      apply();
      scheduleATCMinuteCheck();
    }, delay);
  }

  scheduleATCMinuteCheck();

  scope.on('atc-schedule.3', document, 'visibilitychange', function() {
    if (!document.hidden) apply();
  });

  scope.on('atc-schedule.waitlist-click', root, 'click', function(e) {
    const btn = e.target.closest && e.target.closest('.js-message-button');
    if (!btn || !scheduleClosed || signedUp()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (waitlistForm && waitlistForm.__vaultSending) return; // R50 review: the email is on its way – the box stays shut
    setPanelOpen(true);
    if (waitlistInput && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      scope.timeout(function() {
        if (waitlistForm.classList && waitlistForm.classList.contains('is-open')) waitlistInput.focus({ preventScroll: true });
      }, 520);
    }
    // R45 P0-4-01 (Mark): once the email box has slid open, glide the page so the box sits clearly in view
    scope.timeout(function() {
      if (!waitlistForm.classList || !waitlistForm.classList.contains('is-open')) return;
      const r = waitlistForm.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      let dy = 0;
      if (r.bottom > vh - 90) dy = r.bottom - (vh - 90);
      else if (r.top < 80) dy = r.top - 80;
      if (Math.abs(dy) > 4) window.scrollBy({ top: dy, behavior: 'smooth' });
    }, 540);
  }, true);

  /* The coming-soon page's email field, 1:1 (blocks/ai_gen_block_e305375 initEmailInteractions): blinking placeholder
     when empty, shadow box while focused, ENTER only once something is typed, reminder blink after 20 s idle. */
  if (waitlistInput && waitlistContainer && waitlistSubmit) {
    const placeholder1 = waitlistInput.dataset.placeholder1 || '';
    const placeholder2 = waitlistInput.dataset.placeholder2 || placeholder1;
    let reminderTimer = null;
    const signupVisible = function() { return !waitlist.classList.contains('is-success-active'); };
    const startBlink = function() { if (signupVisible()) waitlistContainer.classList.add('is-blinking'); };
    const stopBlink = function() { waitlistContainer.classList.remove('is-blinking'); };
    const scheduleReminderBlink = function() {
      clearTimeout(reminderTimer);
      if (!signupVisible() || waitlistInput.value.trim().length === 0) return;
      reminderTimer = scope.timeout(function() { if (waitlistInput.value.trim().length > 0 && signupVisible()) startBlink(); }, 20000);
    };
    const applyEmptyState = function(keepFocused) {
      waitlistInput.placeholder = placeholder1;
      waitlistSubmit.classList.remove('visible');
      clearTimeout(reminderTimer);
      startBlink();
      waitlistInput.classList.toggle('focused', !!keepFocused);
    };
    const applyTypingState = function() {
      waitlistInput.classList.add('focused');
      waitlistInput.placeholder = placeholder2;
      waitlistSubmit.classList.add('visible');
      stopBlink();
      scheduleReminderBlink();
    };
    const follow = function(keep) { if (waitlistInput.value.trim().length === 0) applyEmptyState(keep); else applyTypingState(); };
    scope.on('atc-schedule.waitlist-focus', waitlistInput, 'focus', function() { follow(true); });
    scope.on('atc-schedule.waitlist-tap', waitlistInput, 'click', function() { follow(true); });
    scope.on('atc-schedule.waitlist-input', waitlistInput, 'input', function() {
      if (waitlistError && !waitlistError.hidden) waitlistError.hidden = true;
      if (waitlistInput.value.trim().length > 0) applyTypingState(); else applyEmptyState(document.activeElement === waitlistInput);
    });
    scope.on('atc-schedule.waitlist-blur', waitlistInput, 'blur', function() {
      scope.timeout(function() { if (waitlistInput.value.trim().length > 0) scheduleReminderBlink(); else applyEmptyState(false); }, 100);
    });
    follow(false);
    waitlist.__vaultStopBlink = stopBlink;
  }

  /* Sent in place (Mark, Round 13: "it should stay where they are and we'll just change the text"): no reload, no
     preloader, the options and the look stay. Shopify answers a good signup with customer_posted=true. A bot check or
     a failed request falls back to the normal post; the look is restored after that reload. */
  // ---- Round 21: the coming-soon page's success message + scheduler, under the COMING SOON button ----
  const waitlistDone = root.querySelector('[data-vault-waitlist-done]');
  if (waitlistDone && /Android/i.test((window.navigator && window.navigator.userAgent) || '')) waitlistDone.dataset.android = 'true';
  const DONE_HEADER_KEY = 'vault-product-waitlist-header-until';
  const SCHEDULE_CACHE = 'vault-cs-schedule';
  const PHT = 8 * 60 * 60 * 1000, DAY = 24 * 60 * 60 * 1000;
  let doneTimers = [], doneRun = 0;
  function parsePht(v) {
    const m = String(v || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!m) return null;
    const y = +m[1], mo = +m[2], d = +m[3], h = +m[4], mi = +m[5];
    if (h > 23 || mi > 59) return null;
    const t = Date.UTC(y, mo - 1, d, h - 8, mi), c = new Date(t + PHT);
    return c.getUTCFullYear() === y && c.getUTCMonth() === mo - 1 && c.getUTCDate() === d ? t : null;
  }
  function phtAt(t, h, mi) { const d = new Date(t + PHT); return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), h - 8, mi); }
  function phtDate(t) {
    const d = new Date(t + PHT);
    return ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'][d.getUTCMonth()] + ' ' + d.getUTCDate();
  }
  function fillDate(text, t, n) {
    const date = phtDate(t);
    return String(text || '').replace(/\[DATE\]/gi, date).replace(new RegExp('\\[DAY\\s*' + n + '\\s*DATE\\]', 'gi'), date);
  }
  function readScheduleData(el) {
    const d = (el && el.dataset) || {};
    return {
      enabled: d.successScheduleEnabled === 'true', dropDate: d.dropDatetime || '',
      day7: d.day7Datetime || '', day10: d.day10Datetime || '', day12: d.day12Datetime || '',
      defaultHeader: d.defaultSuccessHeader || "YOU'RE ON THE WAITING LIST",
      defaultMessage: d.defaultSuccessMessage || 'WE’LL EMAIL YOU ABOUT THE NEXT VAULT DROP',
      day7Header: d.day7SuccessHeader || "YOU'RE ON THE WAITING LIST",
      day7Message: d.day7SuccessMessage || 'THE COLLECTION REVEALS ON [DAY 7 DATE] AT 8:30 PM PHT',
      day10Header: d.day10SuccessHeader || "YOU'RE ON THE WAITING LIST",
      day10Message: d.day10SuccessMessage || 'PRICELIST + FREE ITEM DETAILS REVEAL ON [DAY 10 DATE] AT 8:30 PM PHT',
      day12Header: d.day12SuccessHeader || "YOU'RE ON THE WAITING LIST",
      day12Message: d.day12SuccessMessage || 'YOUR PASSWORD WILL BE EMAILED ON [DAY 12 DATE] BETWEEN 8:10–8:25 PM PHT'
    };
  }
  let scheduleConfig = readScheduleData(waitlistDone), schedulePromise = null;
  // one source of truth: the coming-soon page's Email subscription block (its editor settings)
  function loadSchedule() {
    if (schedulePromise) return schedulePromise;
    try {
      const cached = JSON.parse(sessionStorage.getItem(SCHEDULE_CACHE) || 'null');
      if (cached && Date.now() - cached.t < 600000) { scheduleConfig = cached.c; return (schedulePromise = Promise.resolve(scheduleConfig)); }
    } catch (e) {}
    const page = waitlistDone && waitlistDone.dataset.schedulePage;
    if (!page || typeof fetch !== 'function' || typeof DOMParser !== 'function') return (schedulePromise = Promise.resolve(scheduleConfig));
    schedulePromise = fetch(page, { credentials: 'same-origin' }).then(function(r) { return r.ok ? r.text() : ''; }).then(function(html) {
      const el = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-success-schedule-enabled]');
      if (el) {
        scheduleConfig = readScheduleData(el);
        try { sessionStorage.setItem(SCHEDULE_CACHE, JSON.stringify({ t: Date.now(), c: scheduleConfig })); } catch (e) {}
      }
      return scheduleConfig;
    }).catch(function() { return scheduleConfig; });
    return schedulePromise;
  }
  function currentSuccess(c, now) {
    const out = { header: c.defaultHeader, message: c.defaultMessage, hidden: false, visibleMs: 15000 };
    if (!c.enabled) return out;
    const drop = parsePht(c.dropDate);
    if (drop === null) return out;
    const d7 = parsePht(c.day7) != null ? parsePht(c.day7) : drop - 5 * DAY;
    const d10 = parsePht(c.day10) != null ? parsePht(c.day10) : drop - 2 * DAY;
    const d12 = parsePht(c.day12) != null ? parsePht(c.day12) : drop;
    const hideStart = phtAt(d12, 20, 0), showAgain = phtAt(d12 + 3 * DAY, 0, 0);
    if (!(d7 < d10 && d10 < hideStart && hideStart < showAgain)) return out;
    if (now >= hideStart && now < showAgain) out.hidden = true;
    else if (now < d7) { out.header = c.day7Header; out.message = fillDate(c.day7Message, d7, 7); }
    else if (now < d10) { out.header = c.day10Header; out.message = fillDate(c.day10Message, d10, 10); }
    else if (now < hideStart) { out.header = c.day12Header; out.message = fillDate(c.day12Message, d12, 12); }
    if (now >= d10 && now < hideStart) out.visibleMs = 25000;
    return out;
  }
  function setDoneText(cur) {
    if (!waitlistDone) return;
    const top = waitlistDone.querySelector('.vault-waitlist-done__top'), bottom = waitlistDone.querySelector('.vault-waitlist-done__bottom');
    if (top && top.textContent !== cur.header) top.textContent = cur.header;
    if (bottom && bottom.textContent !== cur.message) bottom.textContent = cur.message;
  }
  function clearDone() { doneRun++; doneTimers.forEach(function(t) { scope.clear(t); }); doneTimers = []; }
  scope.cleanup(clearDone);
  function showDoneHeaderOnly() {
    if (!waitlistDone) return;
    const run = doneRun;
    loadSchedule().then(function(c) {
      if (run !== doneRun || !scope.alive || !root.isConnected) return;
      const cur = currentSuccess(c, Date.now());
      if (cur.hidden) return;
      setDoneText(cur);
      waitlistDone.classList.remove('is-success-active');
      waitlistDone.classList.add('is-header-only');
    });
  }
  // same motion and timing as the coming-soon page: header, message fades in 4 s, stays 15 s (25 s from Day 10), fades out 1.3 s, header stays
  function playDoneMessage(delayMs, glide) {
    if (!waitlistDone) return;
    clearDone();
    const run = doneRun;
    try { localStorage.setItem(DONE_HEADER_KEY, String(Date.now() + DAY)); } catch (e) {}
    loadSchedule().then(function(c) {
      if (run !== doneRun || !scope.alive || !root.isConnected) return;
      const cur = currentSuccess(c, Date.now());
      if (cur.hidden) return;
      setDoneText(cur);
      const bottom = waitlistDone.querySelector('.vault-waitlist-done__bottom');
      waitlistDone.classList.remove('is-header-only');
      waitlistDone.classList.add('is-success-active');
      if (bottom) bottom.classList.remove('is-visible', 'is-fading-out');
      const centreOnPhone = glide && window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      const reveal = function() {
        if (run !== doneRun || !scope.alive || !root.isConnected) return;
        if (centreOnPhone) centreDoneLine(); // watched where it will show (a finger may have cancelled the glide)
        whenSeen(centreOnPhone ? bottom : waitlistDone, function() {
          if (!bottom || run !== doneRun) return;
          centreDoneLine();
          void bottom.offsetHeight;
          bottom.classList.add('is-visible');
          // Mark R23: ~1/4 of the coming-soon page's time (hold 3.75 s / 6.25 s from Day 10, fade out 0.35 s);
          // R42 P0-4-01: the 1 s ease-out fade read as 'it just appears' on phones – fade in 1.6 s ease-in-out (buy-buttons CSS)
          const hold = Math.round(cur.visibleMs / 4), fadeIn = 1600;
          doneTimers.push(scope.timeout(function() { bottom.classList.remove('is-visible'); bottom.classList.add('is-fading-out'); }, fadeIn + hold));
          doneTimers.push(scope.timeout(function() { bottom.classList.remove('is-fading-out'); showDoneHeaderOnly(); }, fadeIn + hold + 350));
        });
      };
      if (centreOnPhone) {
        glideAfterKeyboard(function() { centreDoneLine(); return confirmationRect(); }, reveal);
      } else doneTimers.push(scope.timeout(reveal, delayMs || 0));
    });
  }
  // Mark R23: the red line sits halfway between the COMING SOON button and the next thing under it (social proof)
  function centreDoneLine() {
    if (!waitlistDone) return;
    const line = waitlistDone.querySelector('.vault-waitlist-done__bottom');
    const btn = Array.prototype.find.call(root.querySelectorAll('.js-message-button'), function(b) { return b.offsetParent; });
    if (!line || !btn) return;
    // the nearest visible thing below the button in the page (the social proof), whatever wraps it
    const top = btn.getBoundingClientRect().bottom;
    let end = Infinity;
    const scopeEl = btn.closest('.product__info-wrapper, .product__info-container, product-info, section') || document.body;
    Array.prototype.forEach.call(scopeEl.querySelectorAll('*'), function(el) {
      if (waitlistDone.contains(el) || el.contains(waitlistDone) || el.contains(btn) || btn.contains(el)) return;
      if ((waitlistForm && waitlistForm.contains(el)) || (el.closest && el.closest('.vault-product-waitlist-form, [data-vault-product-waitlist], [data-vault-waitlist-done]'))) return; // the closing panel is not 'below'
      const r = el.getBoundingClientRect();
      if (r.height < 4 || r.width < 4 || r.top < top + 1) return;
      const cs = getComputedStyle(el);
      if (cs.visibility === 'hidden' || +cs.opacity === 0) return;
      if (r.top < end) end = r.top;
    });
    if (!isFinite(end)) end = top + 40;
    const base = waitlistDone.getBoundingClientRect().top, h = line.offsetHeight || 14;
    line.style.marginTop = '0'; // the block's 6px gap would push it off centre
    line.style.top = Math.round((top + end) / 2 - h / 2 - base) + 'px';
  }
  if (waitlistDone) scope.on('atc-schedule.done-centre', window, 'resize', function() { if (waitlistDone.classList.contains('is-success-active')) centreDoneLine(); });
  function doneHeaderRemembered() {
    try { return Number(localStorage.getItem(DONE_HEADER_KEY) || 0) > Date.now(); } catch (e) { return false; }
  }

  // start the confirmation clock only once the shopper can actually see it: tab visible, element on screen (Mark R19)
  function whenSeen(el, done) {
    let fired = false, io = null;
    function stop() { fired = true; if (io) io.disconnect(); document.removeEventListener('visibilitychange', check); }
    scope.cleanup(stop);
    function fire() { if (fired || !scope.alive || !root.isConnected) return; stop(); done(); }
    let onScreen = !el || typeof IntersectionObserver !== 'function';
    function check() { if (onScreen && document.visibilityState !== 'hidden') fire(); }
    if (!onScreen) {
      io = new IntersectionObserver(function(entries) { onScreen = entries.some(function(e) { return e.isIntersecting; }); check(); }, { threshold: 0.6 });
      io.observe(el);
    }
    document.addEventListener('visibilitychange', check);
    check();
  }
  function showWaitlistSuccess() {
    if (!waitlist) return;
    if (waitlist.__vaultStopBlink) waitlist.__vaultStopBlink();
    if (waitlistError) waitlistError.hidden = true;
    saveSignup();
    // Round 21: the box retracts right away; the coming-soon success message appears under the button instead
    waitlist.dataset.vaultWaitlistState = 'submitted';
    setPanelOpen(false, true);
    if (waitlistInput) waitlistInput.value = '';
    playDoneMessage(520, true);
    whenSeen(root.querySelector('.js-message-button'), function() {
      scope.timeout(function() {
        waitlist.dataset.vaultWaitlistState = 'signed';
        renderScheduledButton(scheduleClosed);
      }, 5000); // button subtitle "YOU'RE ON THE LIST" ~5 s from when it is seen, same as the red line (Mark R23)
    });
  }
  function showWaitlistError(text) {
    if (waitlistForm) waitlistForm.classList.remove('is-sending');
    setPanelOpen(true);
    if (!waitlistError) return;
    const message = String(text || '').trim() || 'PLEASE ENTER A VALID EMAIL';
    if (waitlistError.textContent !== message) waitlistError.textContent = message;
    waitlistError.hidden = false;
    if (waitlistInput) waitlistInput.setAttribute('aria-invalid', 'true');
  }
  function normalWaitlistPost() {
    let entry = null;
    try {
      entry = history.state && history.state.vaultPicker ? Object.assign({}, history.state.vaultPicker) : null;
      if (entry) entry.open = !document.querySelector('.vault-bn-closed');
    } catch (e) { entry = null; }
    try { sessionStorage.setItem(WAITLIST_RETURN, JSON.stringify({ path: location.pathname, search: location.search, entry: entry, x: window.scrollX || 0, y: window.scrollY || 0, t: Date.now() })); } catch (e) {}
    // Retry through a real submit event so Shopify's storefront spam/challenge listener can add its token.
    // The low-level form.submit() path skips that listener and Shopify rejects the post as invalid parameters.
    waitlistForm.__vaultSending = true;
    // Only our delayed handoff may pass through to Shopify's native submit listener.
    const submitNative = function() {
      waitlistForm.__vaultNormalSubmit = true;
      try {
        if (typeof waitlistForm.requestSubmit === 'function') waitlistForm.requestSubmit(waitlistSubmit || undefined);
        else waitlistSubmit.click();
      } catch (e) {
        waitlistForm.__vaultNormalSubmit = false;
        waitlistForm.__vaultSending = false;
        showWaitlistError('PLEASE TRY AGAIN');
      }
    };
    // slide the panel closed first so the page looks normal before the preloader (Mark Round 18)
    if (typeof waitlistForm.requestSubmit === 'function') {
      if (waitlistForm.classList && waitlistForm.classList.contains('is-open')) setPanelOpen(false, true);
      scope.timeout(function() {
        // the box has fully retracted: the button subtitle confirms right away (Mark Round 18c)
        if (waitlist) { waitlist.dataset.vaultWaitlistState = 'submitted'; renderScheduledButton(scheduleClosed); }
        // let the shopper actually read it before the page leaves for the robot check / preloader (Mark R20: too fast on phone)
        scope.timeout(submitNative, 1200);
      }, 520);
      return;
    }
    if (waitlistSubmit && typeof waitlistSubmit.click === 'function') { submitNative(); return; }
    waitlistForm.__vaultSending = false;
    waitlistForm.__vaultNormalSubmit = false;
    showWaitlistError('PLEASE TRY AGAIN');
  }
  // R50: centre the red date line in the visible viewport; leave the R45 opening glide alone.
  function glideIntoView(r) {
    if (!r || typeof window.scrollBy !== 'function') return false;
    const vv = window.visualViewport;
    const offset = (vv && vv.offsetTop) || 0;
    const vh = (vv && vv.height) || window.innerHeight || document.documentElement.clientHeight;
    const dy = (r.top + r.bottom) / 2 - offset - vh / 2;
    if (Math.abs(dy) <= 24) return false;
    const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollBy({ top: dy, behavior: calm ? 'auto' : 'smooth' });
    return true;
  }
  function confirmationRect() {
    const line = waitlistDone && waitlistDone.classList.contains('is-success-active') ? waitlistDone.querySelector('.vault-waitlist-done__bottom') : null;
    return line ? line.getBoundingClientRect() : null;
  }
  let submitGlideRun = 0, waitlistTouchAt = -1e9, waitlistSubmitAt = 0;
  function glideAfterKeyboard(target, done) {
    if (!scope.alive || (root && root.isConnected === false)) return;
    const reveal = function() { if (done && scope.alive && root.isConnected !== false) done(); };
    if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) { reveal(); return; }
    const vv = window.visualViewport, html = document.documentElement;
    if ((vv && vv.scale > 1.05) || waitlistTouchAt > waitlistSubmitAt) { reveal(); return; }
    const run = ++submitGlideRun, started = Date.now();
    // the box started closing at the submit (R50): its 540 ms run counts from there, not from the server's answer
    const shut = (waitlistSubmitAt && waitlistSubmitAt <= started ? waitlistSubmitAt : started) + 540;
    let timer = 0, finished = false, gliding = false, lastMove = started, late = false;
    const keyboardUp = function() { return !!(vv && html && vv.height * (vv.scale || 1) < html.clientHeight - 100); };
    function off() {
      scope.clear(timer);
      if (vv) { vv.removeEventListener('resize', moved); vv.removeEventListener('scroll', moved); }
      window.removeEventListener('scroll', moved);
      window.removeEventListener('touchstart', tookOver, true);
      window.removeEventListener('wheel', tookOver, true);
    }
    function finish() {
      if (finished) return;
      finished = true;
      off();
      if (run !== submitGlideRun) return;
      reveal();
      if (late && vv) recentreWhenDown();
    }
    // the 3 s failsafe centred the line above a keyboard that never reported going down: when it finally does (and the
    // shopper has not touched the page), centre once more in the full screen (R50 review)
    function recentreWhenDown() {
      let stop = 0;
      const once = function() {
        if (keyboardUp()) return;
        vv.removeEventListener('resize', once); scope.clear(stop);
        if (run === submitGlideRun && waitlistTouchAt <= waitlistSubmitAt && scope.alive && root.isConnected !== false && !(vv.scale > 1.05)) glideIntoView(target());
      };
      vv.addEventListener('resize', once);
      stop = scope.timeout(function() { vv.removeEventListener('resize', once); }, 4000);
      scope.cleanup(function() { vv.removeEventListener('resize', once); });
      once(); // the keyboard may already have closed during the first glide
    }
    function tookOver() { finish(); }
    function check() {
      if (finished) return;
      if (run !== submitGlideRun || !scope.alive || root.isConnected === false) { finished = true; off(); return; }
      const now = Date.now();
      if (gliding) {
        // Scroll events, not a per-frame loop: fade only after the glide has stopped for 250 ms.
        const quiet = 250 - (now - lastMove);
        if (quiet > 0) { timer = scope.timeout(check, quiet); return; }
        finish();
        return;
      }
      if (waitlistTouchAt > waitlistSubmitAt || (vv && vv.scale > 1.05)) { finish(); return; }
      // a slow keyboard still owns the viewport: its next resize resumes this; after 3 s (no resize ever came) the line
      // is centred in what is visible and shown anyway – the confirmation must never stay hidden (Claude R50 review)
      if (keyboardUp()) {
        if (now - started < 3000) {
          timer = scope.timeout(check, Math.min(Math.max(1400 - (now - started), 400), 3000 - (now - started)));
          return;
        }
        late = true;
      }
      const wait = Math.max(shut - now, 120 - (now - lastMove));
      if (wait > 0 && now - started < 1400) { timer = scope.timeout(check, Math.min(wait, 1400 - (now - started))); return; }
      gliding = true;
      lastMove = now;
      if (!glideIntoView(target())) { finish(); return; }
      timer = scope.timeout(check, 250);
    }
    function moved() {
      lastMove = Date.now();
      scope.clear(timer);
      timer = scope.timeout(check, gliding ? 250 : Math.min(120, Math.max(0, 1400 - (lastMove - started))));
    }
    if (vv) { vv.addEventListener('resize', moved); vv.addEventListener('scroll', moved); }
    window.addEventListener('scroll', moved, { passive: true });
    window.addEventListener('touchstart', tookOver, { capture: true, passive: true });
    window.addEventListener('wheel', tookOver, { capture: true, passive: true });
    scope.cleanup(function() { finished = true; off(); });
    timer = scope.timeout(check, 120);
  }
  if (waitlistForm) {
    let typed = false, focusId = 0, pointerAt = -1e9, hiddenAt = -1e9;
    ['pointerdown', 'pointerup', 'pointercancel', 'touchstart', 'touchend', 'touchcancel', 'wheel'].forEach(function(type) {
      // a tap inside the email field only moves the caret: it is not the shopper going somewhere else (R50 review)
      scope.on('atc-schedule.waitlist-pointer-' + type, document, type, function(e) { if (!e || e.target !== waitlistInput) pointerAt = Date.now(); }, { capture: true, passive: true });
    });
    // an app switch can blur the field; frames only run again on return – that is never the keyboard's check (R50 review)
    scope.on('atc-schedule.waitlist-hidden', document, 'visibilitychange', function() { if (document.hidden) hiddenAt = Date.now(); });
    if (typeof window.addEventListener === 'function') scope.on('atc-schedule.waitlist-pagehide', window, 'pagehide', function() { hiddenAt = Date.now(); });
    if (waitlistInput) {
      scope.on('atc-schedule.waitlist-done-focus', waitlistInput, 'focusin', function() { focusId++; pointerAt = -1e9; });
      scope.on('atc-schedule.waitlist-done-input', waitlistInput, 'input', function() { typed = true; });
      scope.on('atc-schedule.waitlist-done', waitlistInput, 'focusout', function() {
        if (!typed || waitlistForm.__vaultSending || !window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return;
        const focus = focusId, leftAt = Date.now();
        // Match the phone filter drawer: let the next field/button receive focus before interpreting Safari Done.
        requestAnimationFrame(function() { requestAnimationFrame(function() {
          const active = document.activeElement;
          if (focus !== focusId || !scope.alive || !root.isConnected || !waitlistInput.isConnected || document.visibilityState === 'hidden' || hiddenAt >= leftAt) return;
          if ((active && active !== document.body) || Date.now() - pointerAt < 500 || !typed || waitlistForm.__vaultSending) return;
          if (!waitlistForm.classList.contains('is-open') || !waitlistInput.value.trim() || !waitlistInput.checkValidity()) return;
          if (typeof waitlistForm.requestSubmit === 'function') waitlistForm.requestSubmit(waitlistSubmit || undefined);
          else if (waitlistSubmit) waitlistSubmit.click();
        }); });
      });
    }
    // R47: when the shopper last touched the page (the glide after a submit never pulls them back)
    if (typeof window.addEventListener === 'function') ['touchstart', 'wheel'].forEach(function(type) {
      scope.on('atc-schedule.waitlist-touch-' + type, window, type, function() { waitlistTouchAt = Date.now(); }, { capture: true, passive: true });
    });
    if (waitlistInput) scope.on('atc-schedule.waitlist-enter', waitlistInput, 'keydown', function(e) {
      if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
      e.preventDefault(); // Own Enter/Go instead of also triggering the browser's implicit submit.
      if (e.repeat || waitlistForm.__vaultSending) return;
      if (typeof waitlistForm.requestSubmit === 'function') waitlistForm.requestSubmit(waitlistSubmit || undefined);
      else if (waitlistSubmit) waitlistSubmit.click();
    });
    scope.on('atc-schedule.waitlist-submit', waitlistForm, 'submit', function(e) {
      if (waitlistForm.__vaultNormalSubmit) { waitlistForm.__vaultNormalSubmit = false; return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!waitlistInput || !waitlistInput.checkValidity()) { if (waitlistInput) waitlistInput.reportValidity(); return; }
      if (waitlistForm.__vaultSending) return;
      waitlistForm.__vaultSending = true;
      // R45 P0-4-01: answer the press at once (it felt like Enter needed pressing again): keyboard down, ENTER dims
      if (waitlistForm.classList && waitlistForm.classList.add) waitlistForm.classList.add('is-sending');
      if (waitlistInput && typeof waitlistInput.blur === 'function') waitlistInput.blur();
      // R50 review: the button says YOU'RE ON THE LIST while it sends (as the robot-check post already does, Mark R18c),
      // never CLICK TO JOIN THE LIST; an error re-opens the box with ENTER YOUR EMAIL BELOW
      if (waitlist) waitlist.dataset.vaultWaitlistState = 'submitted';
      setPanelOpen(false, true);
      waitlistSubmitAt = Date.now();
      if (!window.fetch || !window.FormData) { normalWaitlistPost(); return; }
      // a request that never answers (weak signal) goes to the normal post after 12 s instead of leaving the form stuck
      const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      const giveUp = ctrl ? scope.timeout(function() { ctrl.abort(); }, 12000) : 0;
      fetch(waitlistForm.action, { method: 'POST', body: new FormData(waitlistForm), credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function(res) {
          const url = res.url || '';
          if (/customer_posted=true/.test(url)) return { ok: true };
          if (/\/challenge|captcha/i.test(url) || !res.ok) return { native: true };
          return res.text().then(function(html) {
            try {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const form = doc.getElementById(waitlistForm.id);
              const err = form && form.querySelector('.vault-product-waitlist__error');
              if (!form || /challenge|captcha/i.test(html)) return { native: true };
              return err && err.textContent.trim() ? { error: err.textContent } : { native: true };
            } catch (e) { return { native: true }; }
          });
        })
        .then(function(r) {
          scope.clear(giveUp);
          waitlistForm.__vaultSending = false;
          if (!r.native && waitlistForm.classList && waitlistForm.classList.remove) waitlistForm.classList.remove('is-sending');
          if (r.ok) showWaitlistSuccess();
          else if (r.native) normalWaitlistPost();
          else showWaitlistError(r.error);
        })
        .catch(function() { scope.clear(giveUp); waitlistForm.__vaultSending = false; normalWaitlistPost(); });
    }, true);
  }

  function afterPreloader(callback) {
    const preloader = document.getElementById && document.getElementById('preloader');
    const gone = function() {
      if (!preloader || !preloader.isConnected) return true;
      const style = window.getComputedStyle ? window.getComputedStyle(preloader) : null;
      return preloader.classList.contains('preloader--hide') || style && (style.visibility === 'hidden' || style.opacity === '0');
    };
    if (gone()) { scope.timeout(callback, 0); return; }
    let done = false;
    const finish = function() { if (done || !gone()) return; done = true; if (observer) observer.disconnect(); callback(); };
    const observer = 'MutationObserver' in window ? new MutationObserver(finish) : null;
    if (observer) scope.observe(observer).observe(preloader, { attributes: true, attributeFilter: ['class', 'style'] });
    scope.timeout(finish, 4000);
  }

  const ownWaitlistResponse = isOwnWaitlistResponse();
  let waitlistReturn = null;
  if (ownWaitlistResponse) {
    // after a normal post Shopify drops ?style=/&lv=: bring the shopper back to the same look once
    try {
      // the look, the open options and the address were put back before the picker started (main-product, top)
      const storedReturn = window.__vaultWaitlistReturn || JSON.parse(sessionStorage.getItem(WAITLIST_RETURN) || 'null');
      waitlistReturn = storedReturn && storedReturn.path === location.pathname && Date.now() - storedReturn.t < 600000 ? storedReturn : null;
      if (waitlistReturn && waitlist && waitlist.dataset.postedSuccessfully === 'true') sessionStorage.removeItem(WAITLIST_RETURN);
    } catch (e) {}
  }
  function restoreWaitlistScroll() {
    if (!waitlistReturn || typeof window.scrollTo !== 'function') return;
    window.scrollTo(waitlistReturn.x || 0, waitlistReturn.y || 0);
  }
  if (waitlist && ownWaitlistResponse && waitlist.dataset.hasErrors === 'true') {
    setPanelOpen(true);
    restoreWaitlistScroll();
  } else if (waitlist && ownWaitlistResponse && waitlist.dataset.postedSuccessfully === 'true') {
    // the panel already slid closed before the reload: stay closed, just remember the signup (Mark Round 18b)
    saveSignup();
    waitlist.dataset.vaultWaitlistState = 'submitted';
    renderScheduledButton(scheduleClosed);
    restoreWaitlistScroll();
    // count 4 s only after the preloader is gone and the button is on screen (captcha time does not count) (Mark R19)
    afterPreloader(function() {
      playDoneMessage(700, true); // phones: centred like after an Enter (R50 review)
      whenSeen(root.querySelector('.js-message-button'), function() {
        scope.timeout(function() {
          waitlist.dataset.vaultWaitlistState = 'signed';
          renderScheduledButton(scheduleClosed);
        }, 5000);
      });
    });
    try {
      const clean = new URL(window.location.href);
      clean.searchParams.delete('customer_posted'); clean.hash = '';
      history.replaceState(Object.assign({}, history.state), '', clean.pathname + clean.search);
    } catch (e) {}
  } else if (waitlist) {
    waitlist.dataset.vaultWaitlistState = signedUp() ? 'signed' : 'before';
    if (signedUp() && doneHeaderRemembered()) showDoneHeaderOnly();
  }

  // If Shopify swaps HTML (rare but happens)
  if ('MutationObserver' in window) {
    scope.observe(new MutationObserver(function(){ apply(); })).observe(root, { childList: true, subtree: true });
  }

  apply();
})();

    },
    "restock": function (root, config, scope) {

(function () {
  if (!root) return;

  const productTitle = config.productTitle;
  const hasOnlyDefaultVariant = config.hasOnlyDefaultVariant;
  const scheduleFlag = config.scheduleFlag;
  const scheduleOn = (scheduleFlag === true || scheduleFlag === 'true');

  function currentVariant() {
    const input = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    const list = variantList(root);
    if (!input || !input.value) return null;
    return list.find(v => String(v.id) === String(input.value)) || null;
  }

  // Swap ADD TO CART <-> OUT OF STOCK when the shopper picks another variant.
  // COMING SOON products are left to the schedule script above.
  function syncButtons() {
    if (scheduleOn) return;
    const v = currentVariant();
    const sold = !v || v.available === false;
    root.querySelectorAll('.js-add-to-cart').forEach(btn => { btn.style.display = sold ? 'none' : ''; });
    root.querySelectorAll('.js-message-button').forEach(btn => { btn.style.display = sold ? '' : 'none'; });
  }

  scope.on('restock.0', root, 'change', function (e) {
    if (e.target.matches('input[name="id"]')) syncButtons();
  });

  // Open the shopper's email app with the subject and message already typed in.
  scope.on('restock.1', root, 'click', function (e) {
    const btn = e.target.closest('.js-message-button');
    if (!btn || btn.protocol !== 'mailto:') return;
    e.preventDefault();

    const v = currentVariant();
    const picker = root.querySelector('vault-picker');
    const picked = v && v.title ? v.title : (picker && picker.dataset.selection);
    const name = (!hasOnlyDefaultVariant && picked) ? productTitle + ' — ' + picked : productTitle;
    const subject = (scheduleOn ? 'Coming soon: ' : 'Restock request: ') + name;
    const body = scheduleOn
      ? 'Hi VAULT! \n\nI’m interested in ' + name + ', but it’s not available yet\n\nCan you add me to the list?'
      : 'Hi VAULT! \n\nI’m interested in ' + name + ', but it’s currently sold out\n\nCan you let me know if it will be restocked?';

    const address = btn.href.split('?')[0];
    window.location.href = address + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  });
  syncButtons();
})();

    }
  };
  window.VaultProduct = window.VaultProduct || {
    phases: phases,
    init: function (phase, root, config) {
      if (shared.has(phase)) {
        if (installed.has(phase)) return;
        installed.add(phase);
        root = document.documentElement;
      }
      var scopeName = phase === 'atc-schedule' ? 'ProductAtcSchedule' : phase === 'restock' ? 'ProductRestock' : 'Product';
      var scope = /^(atc-schedule|restock)$/.test(phase)
        ? window.vaultInit.scope.replace(root, scopeName)
        : window.vaultInit.scope(root, scopeName);
      phases[phase](root, config, scope);
    }
  };
  window.vaultInit.drain('Product');
})();
